const translations = {
  en: {
    nav_advisor: "Advisor",
    nav_history: "History",
    nav_login: "Sign In",
    nav_register: "Sign Up",
    nav_logout: "Sign Out",
    nav_projects: "Projects",
    nav_careers: "Careers",
    gear_quickfill: "Quick Fill from Your Gear",
    gear_my_cameras: "My Cameras",
    gear_my_lenses: "My Lenses",
    nav_guide: "User Guide",
    nav_lighting_basics: "Lighting Basics",
    nav_lighting: "Lighting Techniques",
    nav_golden_hour: "Golden Hour",
    nav_glossary: "Glossary",
    nav_studio: "Studio",
    nav_printing: "Printing",
    nav_learn: "Learn",
    nav_shots: "Types of Shots",
    nav_calibration: "Monitor Calibration",
    nav_tether: "Tether Photography",
    nav_histogram: "The Histogram",
    nav_metering: "Metering Modes",
    nav_exposure: "Exposure Compensation",
    nav_cropfactor: "Crop Factor",
    nav_filters: "Hardware Filters",
    nav_compression: "Lens Compression",
    nav_focus: "Advanced Focus",
    nav_whitebalance: "White Balance & DR",
    nav_graycard: "The Gray Card",
    nav_smartphone: "Smartphone Photography",
    nav_film: "Film Photography (35mm)",
    nav_bw: "Black & White Photography",
    nav_checklist: "Prep Checklist",
    nav_poses: "Posing Guide",
    nav_mode_dial: "Camera Mode Dial",
    nav_light_meter: "Light Meter",
    nav_maintenance: "Maintenance & Care",
    nav_anatomy: "Camera Anatomy",
    nav_bayer: "The Bayer Filter",
    nav_camera_history: "History of the Camera",

    nav_forms: "Contracts & Forms",

    auth_login_title: "Welcome Back",
    auth_login_subtitle: "Sign in to save your camera settings",
    auth_register_title: "Create Account",
    auth_register_subtitle: "Start saving your camera settings",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Full Name",
    auth_login_btn: "Sign In",
    auth_register_btn: "Create Account",
    auth_no_account: "Don't have an account?",
    auth_have_account: "Already have an account?",

    form_camera_lens: "Camera & Lens",
    form_camera: "Camera Body",
    form_focal_length: "Focal Length",
    form_max_aperture: "Max Aperture",
    form_mm: "mm",
    form_scene: "Scene & Lighting",
    form_lighting_type: "Lighting Type",
    form_light_condition: "Light Condition",
    form_time_of_day: "Time of Day",
    form_time_of_day_hint: "Times are approximate and may vary by location and season.",
    form_photo_type_title: "Photo Type",
    form_options: "Options",
    form_tripod: "Using Tripod",
    form_subject_movement: "Subject Movement",
    form_depth_of_field: "Depth of Field",
    form_lens_type: "Lens Type",
    form_calculate: "Calculate Settings",
    form_calculating: "Calculating...",

    cam_canon_eos_rebel_t3i: "Canon EOS Rebel T3i",
    cam_canon_eos_rebel_t7: "Canon EOS Rebel T7 / 2000D",
    cam_canon_eos_20d: "Canon EOS 20D",
    cam_canon_eos_80d: "Canon EOS 80D",
    cam_canon_eos_5d_mark_iii: "Canon EOS 5D Mark III",
    cam_canon_eos_r50: "Canon EOS R50",
    cam_canon_eos_1dx_mark_iii: "Canon EOS-1D X Mark III",
    cam_canon_eos_rebel_t8i: "Canon EOS 850D / Rebel T8i",
    cam_canon_eos_90d: "Canon EOS 90D",
    cam_canon_eos_250d: "Canon EOS 250D / Rebel SL3",
    cam_canon_eos_5d_mark_iv: "Canon EOS 5D Mark IV",
    cam_canon_eos_6d_mark_ii: "Canon EOS 6D Mark II",
    cam_canon_eos_4000d: "Canon EOS 4000D / Rebel T100",
    cam_canon_eos_r3: "Canon EOS R3",
    cam_canon_eos_r5: "Canon EOS R5 / R5 Mark II",
    cam_canon_eos_r6: "Canon EOS R6 / R6 Mark II",
    cam_canon_eos_r8: "Canon EOS R8",
    cam_canon_eos_r7: "Canon EOS R7",
    cam_canon_eos_r10: "Canon EOS R10",
    cam_canon_eos_r100: "Canon EOS R100",
    cam_canon_eos_r: "Canon EOS R",
    cam_canon_eos_rp: "Canon EOS RP",
    cam_nikon_d3200: "Nikon D3200",
    cam_nikon_d3500: "Nikon D3500",
    cam_nikon_d5600: "Nikon D5600",
    cam_nikon_d750: "Nikon D750",
    cam_nikon_coolpix_p100: "Nikon Coolpix P100",
    cam_nikon_d6: "Nikon D6",
    cam_nikon_d780: "Nikon D780",
    cam_nikon_d850: "Nikon D850",
    cam_nikon_d7500: "Nikon D7500",
    cam_nikon_z9: "Nikon Z9",
    cam_nikon_z8: "Nikon Z8",
    cam_nikon_z7ii: "Nikon Z7 / Z7 II",
    cam_nikon_z6iii: "Nikon Z6 III",
    cam_nikon_z5: "Nikon Z5 / Z5 II",
    cam_nikon_zf: "Nikon Zf",
    cam_nikon_z50: "Nikon Z50 / Z50 II",
    cam_nikon_zfc: "Nikon Zfc",
    cam_nikon_z30: "Nikon Z30",
    cam_sony_a99ii: "Sony A99 II",
    cam_sony_a58: "Sony A58",
    cam_sony_a1: "Sony A1",
    cam_sony_a9iii: "Sony A9 III",
    cam_sony_a7rv: "Sony A7R V",
    cam_sony_a7iv: "Sony A7 IV",
    cam_sony_a7siii: "Sony A7S III",
    cam_sony_a7cii: "Sony A7C II",
    cam_sony_zve1: "Sony ZV-E1",
    cam_sony_a6700: "Sony A6700",
    cam_sony_a6400: "Sony A6400",
    cam_sony_a6100: "Sony A6100",
    cam_sony_zve10: "Sony ZV-E10 II",
    cam_sony_fx3: "Sony FX3",
    cam_sony_fx30: "Sony FX30",
    cam_fujifilm_xh2: "Fujifilm X-H2",
    cam_fujifilm_xs10: "Fujifilm X-S10",
    cam_fujifilm_xt50: "Fujifilm X-T50",
    cam_fujifilm_xe4: "Fujifilm X-E4",
    cam_fujifilm_xa7: "Fujifilm X-A7",
    cam_fujifilm_gfx100ii: "Fujifilm GFX 100 II",
    cam_fujifilm_gfx50sii: "Fujifilm GFX 50S II",
    cam_fujifilm_s5pro: "Fujifilm FinePix S5 Pro",
    cam_fujifilm_s3pro: "Fujifilm FinePix S3 Pro",
    cam_pentax_k70: "Pentax K-70",
    cam_pentax_kf: "Pentax KF",
    cam_sony_a68: "Sony A68 (SLT)",
    cam_sony_a77_ii: "Sony A77 II (SLT)",
    cam_fujifilm_x100vi: "Fujifilm X100VI",
    cam_fujifilm_xt5: "Fujifilm X-T5",
    cam_fujifilm_xs20: "Fujifilm X-S20",
    cam_fujifilm_xt30ii: "Fujifilm X-T30 II",
    cam_fujifilm_xh2s: "Fujifilm X-H2S",
    cam_fujifilm_xm5: "Fujifilm X-M5",
    cam_fujifilm_xpro3: "Fujifilm X-Pro3",
    cam_fujifilm_gfx100s: "Fujifilm GFX 100S",
    cam_fujifilm_xt4: "Fujifilm X-T4",
    cam_fujifilm_xt3: "Fujifilm X-T3",
    cam_fujifilm_xt2: "Fujifilm X-T2",
    cam_fujifilm_xh1: "Fujifilm X-H1",
    cam_custom: "My camera is not listed",

    custom_sensor_type: "Sensor Type",
    custom_iso_performance: "ISO Performance",
    sensor_full_frame: "Full Frame (1.0x)",
    sensor_apsc_canon: "APS-C Canon (1.6x)",
    sensor_apsc_other: "APS-C Nikon/Pentax/Sony (1.5x)",
    sensor_micro43: "Micro Four Thirds (2.0x)",
    sensor_one_inch: "1-inch sensor (2.7x)",
    iso_perf_excellent: "Excellent (modern full-frame)",
    iso_perf_good: "Good (modern APS-C / older FF)",
    iso_perf_moderate: "Moderate (typical APS-C)",
    iso_perf_limited: "Limited (older or small sensor)",

    lens_standard: "Standard",
    lens_wide: "Wide",
    lens_telephoto: "Telephoto",
    lens_macro: "Macro",

    lt_natural: "Natural",
    lt_artificial: "Artificial",
    lt_mixed: "Mixed",

    lc_bright_sun: "Bright Sun",
    lc_cloudy: "Cloudy",
    lc_shade: "Shade",
    lc_golden_hour: "Golden Hour",
    lc_blue_hour: "Blue Hour",
    lc_indoor_window: "Indoor (Window)",
    lc_indoor_room: "Indoor (Room)",
    lc_studio: "Studio Light",
    lc_night_street: "Night Street",
    lc_low_light: "Low Light / Dark",

    tod_sunrise: "Sunrise (5:30 – 7:00 AM)",
    tod_morning: "Morning (7:00 – 11:00 AM)",
    tod_noon: "Noon (11:00 AM – 1:00 PM)",
    tod_afternoon: "Afternoon (1:00 – 5:00 PM)",
    tod_sunset: "Sunset (5:00 – 7:30 PM)",
    tod_blue_hour: "Blue Hour (before sunrise / after sunset)",
    tod_night: "Night (after 8:00 PM)",

    pt_portrait: "Portrait",
    pt_landscape: "Landscape",
    pt_sports: "Sports / Action",
    pt_macro: "Macro",
    pt_street: "Street",
    pt_wildlife: "Wildlife",
    pt_product: "Product",
    pt_event_indoor: "Event / Indoor",
    pt_general: "General",

    mv_still: "Still",
    mv_slow: "Slow",
    mv_fast: "Fast",

    dof_shallow: "Shallow",
    dof_medium: "Medium",
    dof_deep: "Deep",

    res_title: "Recommended Settings",
    res_aperture: "Aperture",
    res_shutter: "Shutter Speed",
    res_iso: "ISO",
    res_ev: "EV",
    res_explanation: "Why These Settings",
    res_warnings: "Warnings",
    res_camera_advice: "Camera Advice",
    res_alternatives: "Alternative Settings",
    res_balanced: "Balanced",
    res_balanced_desc: "Moderate settings, no extremes",
    res_safer: "Safer",
    res_safer_desc: "Lower ISO, less noise",
    res_action: "Action",
    res_action_desc: "Faster shutter, freeze motion",
    res_iso_zone_ideal: "Clean",
    res_iso_zone_acceptable: "Some Noise",
    res_iso_zone_caution: "High Noise",
    res_save: "Save to History",
    res_starting_note: "These recommendations are starting points. Adjust after your first test shot.",
    mode_manual: "Manual",
    mode_ai: "Describe Your Shot",
    ai_title: "Describe Your Shot",
    ai_subtitle: "Tell the AI what you want to photograph and get a starting point in plain language.",
    ai_textarea_label: "What do you want to photograph?",
    ai_placeholder: "e.g. I want to photograph a full moon at night with my Tamron 70-300mm on a tripod",
    ai_examples_label: "Try an example",
    ai_tod_label: "Time of day (optional)",
    ai_setting_label: "Setting (optional)",
    tod_sunrise: "Sunrise",
    tod_morning: "Morning",
    tod_midday: "Midday",
    tod_afternoon: "Afternoon",
    tod_golden: "Golden Hour",
    tod_blue: "Blue Hour",
    tod_night: "Night",
    set_outdoor: "Outdoor",
    set_indoor: "Indoor",

    ai_example_1: "Indoor birthday party, low light, kids running around",
    ai_example_2: "Golden hour portrait in a park with a creamy blurry background",
    ai_example_3: "Fast-moving soccer game on a bright sunny afternoon",
    ai_example_4: "Silky long-exposure waterfall on an overcast day",
    ai_submit: "Get AI Settings",
    ai_generating: "Thinking...",
    ai_gear_hint: "Your saved gear will be used to recommend the best lens.",
    ai_gear_hint_none: "Tip: add your gear in My Gear so the AI can pick the best lens you own.",
    ai_empty_error: "Please describe the shot you want to take.",
    ai_error: "Something went wrong. Please try again.",
    ai_results_title: "AI Recommended Settings",
    ai_scene: "Scenario",
    ai_lens_label: "Recommended Lens",
    ai_from_your_gear: "From your gear",
    ai_suggested_lens: "Suggested type",
    ai_protips: "Pro Tips",
    ai_lighting_title: "Lighting Setup",
    ai_lighting_badge: "Suggested",
    ai_lighting_learn: "Learn lighting basics",


    ai_empty_title: "Describe Your Shot",
    ai_empty: "Type a plain-language description of the photo you want to take, and the AI will suggest a starting point.",
    ai_disclaimer: "AI suggestions are a starting point. Adjust after your first test shot.",
    ai_apply: "Apply to Manual Form",
    ai_apply_hint: "Fine-tune these settings with the full manual controls, then save to History.",
    ai_apply_tooltip: "Switches to Manual mode and pre-fills the calculator with the AI's reading of your shot, so you can fine-tune each control, recalculate, and save it to History.",

    ai_applied: "Applied! Fine-tune and press Calculate to save.",
    found_badge: "Foundations",
    found_title: "New here? Start with the fundamentals",
    found_sub: "Three short lessons that explain the camera itself — before you dive into the settings.",
    found_anatomy_desc: "How a DSLR & mirrorless camera works",
    found_bayer_desc: "How sensors see color",
    found_history_desc: "From the camera obscura to AI",



    res_saved: "Saved!",
    res_empty_title: "Ready to Calculate",
    res_empty: "Configure your camera settings and press Calculate to get personalized recommendations.",

    warn_high_iso_noise: "ISO is above the preferred range. Expect some visible noise.",
    warn_high_iso_extreme: "ISO is well above the recommended limit. Significant noise expected.",
    warn_camera_iso_canon_eos_rebel_t3i: "Canon T3i: ISO pushed above 800. Usable up to 1600, but expect grain in shadows.",
    warn_camera_iso_canon_eos_rebel_t7: "Canon T7: ISO above 800 will show noise. Keep under 1600 for clean results.",
    warn_camera_iso_canon_eos_20d: "Canon 20D: High ISO introduces visible noise. Keep below 400 for clean images — above 800 degrades significantly.",
    warn_camera_iso_canon_eos_80d: "Canon 80D: ISO above 1600 will show some noise. Usable up to 3200 with some post-processing.",
    warn_camera_iso_canon_eos_5d_mark_iii: "5D Mark III: Full-frame sensor handles high ISO well. Usable up to 6400, but watch shadows above 3200.",
    warn_camera_iso_canon_eos_r50: "Canon R50 handles high ISO well. Comfortable up to 3200, still usable at 6400.",
    warn_camera_iso_canon_eos_1dx_mark_iii: "1D X Mark III: Professional flagship with exceptional ISO performance. Clean up to 6400, very usable at 25600.",
    warn_camera_iso_canon_eos_rebel_t8i: "Canon 850D/T8i: Good APS-C performance. Clean up to 1600, usable to 3200. Improved over previous Rebels.",
    warn_camera_iso_canon_eos_90d: "Canon 90D: Strong APS-C performer. Clean up to 1600, usable to 6400. 32.5MP with fast burst.",
    warn_camera_iso_canon_eos_250d: "Canon 250D: Entry-level APS-C. Clean up to 800, usable to 1600. Lightweight and beginner-friendly.",
    warn_camera_iso_canon_eos_5d_mark_iv: "5D Mark IV: Full-frame workhorse. Excellent ISO up to 3200, very usable at 12800. Professional-grade low-light.",
    warn_camera_iso_canon_eos_6d_mark_ii: "6D Mark II: Full-frame with good ISO performance. Clean up to 3200, usable to 6400. Great value full-frame.",
    warn_camera_iso_canon_eos_4000d: "Canon 4000D: Budget entry-level. ISO best kept under 400, above 1600 degrades significantly. Best in good light.",
    warn_camera_iso_canon_eos_r3: "EOS R3: Professional mirrorless with stacked sensor. Exceptional ISO up to 6400, very usable at 25600. Built for speed.",
    warn_camera_iso_canon_eos_r5: "EOS R5: 45MP full-frame. Excellent ISO up to 6400, very usable at 12800. Outstanding resolution and low-light balance.",
    warn_camera_iso_canon_eos_r6: "EOS R6: 20MP full-frame optimized for low-light. Excellent ISO up to 6400, very usable at 12800. IBIS helps further.",
    warn_camera_iso_canon_eos_r8: "EOS R8: Compact full-frame. Good ISO up to 3200, very usable at 12800. Lightweight but capable sensor.",
    warn_camera_iso_canon_eos_r7: "EOS R7: High-end APS-C mirrorless. Clean up to 3200, usable to 6400. IBIS and fast burst for action.",
    warn_camera_iso_canon_eos_r10: "EOS R10: Mid-range APS-C mirrorless. Clean up to 1600, usable to 6400. Great autofocus for the price.",
    warn_camera_iso_canon_eos_r100: "EOS R100: Budget mirrorless. Clean up to 800, usable to 1600. No IBIS — keep shutter speed fast.",
    warn_camera_iso_canon_eos_r: "EOS R: Original full-frame mirrorless. Clean up to 3200, usable to 6400. Solid performer in good conditions.",
    warn_camera_iso_canon_eos_rp: "EOS RP: Entry full-frame mirrorless. Clean up to 3200, usable to 6400. Affordable full-frame option.",
    warn_camera_iso_nikon_d3200: "Nikon D3200: ISO above 800 shows noticeable noise. Stay under 800 when possible.",
    warn_camera_iso_nikon_d3500: "Nikon D3500: ISO above 800 will show noise. Clean up to 800, usable to 1600.",
    warn_camera_iso_nikon_d5600: "Nikon D5600: ISO above 1600 shows some noise. Good up to 3200 with care.",
    warn_camera_iso_nikon_d750: "Nikon D750: Full-frame handles high ISO very well. Clean up to 3200, usable to 6400.",
    warn_camera_iso_nikon_coolpix_p100: "Coolpix P100: Small sensor produces significant noise above ISO 400. Keep as low as possible.",
    warn_camera_iso_nikon_d6: "Nikon D6: Professional flagship. Exceptional ISO up to 6400, usable at 25600. Built for low-light speed.",
    warn_camera_iso_nikon_d780: "Nikon D780: Full-frame all-rounder. Excellent ISO up to 3200, very usable at 12800. Hybrid DSLR/mirrorless AF.",
    warn_camera_iso_nikon_d850: "Nikon D850: 45.7MP full-frame. Excellent ISO up to 3200, usable at 12800 despite high resolution.",
    warn_camera_iso_nikon_d7500: "Nikon D7500: Enthusiast APS-C. Good ISO up to 1600, usable to 6400. Same sensor as the D500.",
    warn_camera_iso_nikon_z9: "Nikon Z9: Professional mirrorless flagship. Exceptional ISO up to 6400, very usable at 25600. No mechanical shutter.",
    warn_camera_iso_nikon_z8: "Nikon Z8: Same sensor as Z9 in smaller body. Exceptional ISO up to 6400, very usable at 25600.",
    warn_camera_iso_nikon_z7ii: "Nikon Z7 II: 45.7MP full-frame. Excellent ISO up to 3200, usable at 12800. Outstanding detail and dynamic range.",
    warn_camera_iso_nikon_z6iii: "Nikon Z6 III: Partially stacked sensor. Excellent ISO up to 6400, very usable at 12800. Great all-rounder.",
    warn_camera_iso_nikon_z5: "Nikon Z5: Entry full-frame. Good ISO up to 3200, usable to 6400. IBIS helps keep ISO lower.",
    warn_camera_iso_nikon_zf: "Nikon Zf: Retro full-frame with modern sensor. Excellent ISO up to 6400, very usable at 12800. IBIS included.",
    warn_camera_iso_nikon_z50: "Nikon Z50: Compact APS-C mirrorless. Good ISO up to 1600, usable to 6400. Great travel camera.",
    warn_camera_iso_nikon_zfc: "Nikon Zfc: Retro APS-C mirrorless. Good ISO up to 1600, usable to 6400. Same sensor as Z50.",
    warn_camera_iso_nikon_z30: "Nikon Z30: Vlogging APS-C. Moderate ISO up to 1600, usable to 3200. No IBIS or viewfinder.",
    warn_camera_iso_sony_a99ii: "Sony A99 II: Full-frame SLT. Good ISO up to 3200, usable to 6400. 42MP with SLT mirror costs ~1/3 stop.",
    warn_camera_iso_sony_a58: "Sony A58: Entry-level SLT. Moderate ISO up to 800, usable to 1600. Best in good lighting conditions.",
    warn_camera_iso_sony_a1: "Sony A1: 50MP flagship. Exceptional ISO up to 6400, very usable at 25600. 30fps with full AF tracking.",
    warn_camera_iso_sony_a9iii: "Sony A9 III: Global shutter sports camera. Excellent ISO up to 6400, usable at 12800. Zero rolling shutter distortion.",
    warn_camera_iso_sony_a7rv: "Sony A7R V: 61MP full-frame. Excellent ISO up to 3200, usable at 12800. AI-based AF system.",
    warn_camera_iso_sony_a7iv: "Sony A7 IV: 33MP full-frame all-rounder. Excellent ISO up to 6400, very usable at 12800. Great hybrid camera.",
    warn_camera_iso_sony_a7siii: "Sony A7S III: 12MP video specialist. Exceptional ISO up to 12800, very usable at 25600. Best low-light mirrorless.",
    warn_camera_iso_sony_a7cii: "Sony A7C II: Compact full-frame. Excellent ISO up to 3200, usable at 12800. Same sensor as A7 IV in smaller body.",
    warn_camera_iso_sony_zve1: "Sony ZV-E1: Full-frame vlogging camera. Exceptional ISO up to 12800. A7S III sensor in vlog-friendly body.",
    warn_camera_iso_sony_a6700: "Sony A6700: Top APS-C mirrorless. Good ISO up to 3200, usable to 6400. Latest AI AF and IBIS.",
    warn_camera_iso_sony_a6400: "Sony A6400: Popular APS-C with excellent AF. Good ISO up to 1600, usable to 6400. No IBIS.",
    warn_camera_iso_sony_a6100: "Sony A6100: Entry APS-C mirrorless. Moderate ISO up to 1600, usable to 3200. Good AF but no IBIS.",
    warn_camera_iso_sony_zve10: "Sony ZV-E10 II: APS-C vlogging camera. Moderate ISO up to 1600, usable to 3200. Vlog-focused features.",
    warn_camera_iso_sony_fx3: "Sony FX3: Cinema full-frame. Exceptional ISO up to 12800. A7S III sensor optimized for video production.",
    warn_camera_iso_sony_fx30: "Sony FX30: Cinema APS-C. Good ISO up to 3200, usable to 6400. Professional video features in crop sensor.",
    warn_camera_iso_fujifilm_xh2: "Fujifilm X-H2: 40MP APS-C. Excellent ISO up to 3200, usable to 6400. Non-stacked sensor for maximum resolution.",
    warn_camera_iso_fujifilm_xs10: "Fujifilm X-S10: Mid-range APS-C with IBIS. Good ISO up to 1600, usable to 6400. Traditional controls.",
    warn_camera_iso_fujifilm_xt50: "Fujifilm X-T50: Compact 40MP APS-C. Good ISO up to 3200, usable to 6400. Film simulation dial.",
    warn_camera_iso_fujifilm_xe4: "Fujifilm X-E4: Minimal rangefinder-style. Good ISO up to 1600, usable to 6400. Compact and stylish.",
    warn_camera_iso_fujifilm_xa7: "Fujifilm X-A7: Entry-level APS-C. Moderate ISO up to 800, usable to 1600. Bayer sensor (no X-Trans).",
    warn_camera_iso_fujifilm_gfx100ii: "GFX 100 II: 102MP medium format flagship. Exceptional ISO up to 6400, usable at 12800. Phase-detect AF.",
    warn_camera_iso_fujifilm_gfx50sii: "GFX 50S II: 51MP medium format. Good ISO up to 1600, usable to 6400. Affordable medium format entry.",
    warn_camera_iso_fujifilm_s5pro: "FinePix S5 Pro: Legacy Super CCD. Limited ISO up to 400, usable to 800. Known for exceptional skin tones.",
    warn_camera_iso_fujifilm_s3pro: "FinePix S3 Pro: Legacy Super CCD. Limited ISO — best under 200, usable to 400. Nikon F-mount body.",
    warn_camera_iso_pentax_k70: "Pentax K-70: ISO above 1600 shows some noise. In-body stabilization helps keep ISO lower.",
    warn_camera_iso_pentax_kf: "Pentax KF: ISO above 1600 shows some noise. Use stabilization to keep ISO down.",
    warn_camera_iso_sony_a68: "Sony A68: ISO above 1600 introduces visible noise. Keep under 1600 for clean results.",
    warn_camera_iso_sony_a77_ii: "Sony A77 II: Good up to ISO 1600, usable to 6400. SLT mirror costs about 1/3 stop of light.",
    warn_camera_iso_fujifilm_x100vi: "Fujifilm X100VI: Excellent ISO performance. Clean up to 3200, very usable at 6400. 40MP sensor with IBIS.",
    warn_camera_iso_fujifilm_xt5: "Fujifilm X-T5: Excellent 40MP sensor. Clean up to ISO 3200, very usable at 6400. IBIS helps keep ISO lower.",
    warn_camera_iso_fujifilm_xs20: "Fujifilm X-S20: Good ISO performance. Clean up to 1600, usable to 6400. IBIS and great battery life.",
    warn_camera_iso_fujifilm_xt30ii: "Fujifilm X-T30 II: Good ISO performance. Clean up to 1600, usable to 6400. Compact and travel-friendly.",
    warn_camera_iso_fujifilm_xh2s: "Fujifilm X-H2S: Stacked sensor excels at high ISO. Clean up to 3200, very usable at 12800. Built for speed.",
    warn_camera_iso_fujifilm_xm5: "Fujifilm X-M5: Entry-level ISO performance. Clean up to 800, usable to 3200. Best results in good light.",
    warn_camera_iso_fujifilm_xpro3: "Fujifilm X-Pro3: Good ISO performance. Clean up to 1600, usable to 6400. Hybrid viewfinder is unique.",
    warn_camera_iso_fujifilm_gfx100s: "Fujifilm GFX 100S: Medium format sensor handles ISO exceptionally. Clean up to 3200, usable to 12800.",
    warn_camera_iso_fujifilm_xt4: "Fujifilm X-T4: Good ISO performance. Clean up to 1600, usable to 6400. IBIS and fast burst.",
    warn_camera_iso_fujifilm_xt3: "Fujifilm X-T3: Good ISO performance. Clean up to 1600, usable to 6400. Excellent autofocus system.",
    warn_camera_iso_fujifilm_xt2: "Fujifilm X-T2: Good ISO performance. Clean up to 1600, usable to 6400. 24MP X-Trans III sensor with dual card slots.",
    warn_camera_iso_fujifilm_xh1: "Fujifilm X-H1: Good ISO performance. Clean up to 1600, usable to 6400. First X-series with IBIS — helps keep ISO lower.",
    warn_camera_iso_custom: "Custom camera: ISO pushed above the preferred range for your selected performance level.",
    warn_motion_blur_risk: "Shutter speed may be too slow for handheld. Risk of motion blur.",
    warn_tripod_recommended: "A tripod is strongly recommended at this shutter speed.",
    warn_macro_tripod_warning: "Macro photography benefits greatly from tripod stability.",
    warn_macro_shallow_dof: "Macro photography has extremely shallow depth of field at close distances.",
    warn_macro_handheld_blur: "Handheld macro shooting significantly increases motion blur risk due to magnification.",
    warn_macro_consider_light: "Consider using a ring light, flash, or additional lighting for macro work.",
    warn_consider_flash: "Consider using flash or additional lighting.",
    warn_tripod_would_help: "A tripod would allow lower ISO for significantly cleaner images in this light.",
    warn_low_light_challenging: "Challenging low-light conditions. Image quality may be affected.",
    warn_exposure_limited: "Camera ISO is at its limit. Image may be underexposed.",

    adv_t3i_advice: "Canon EOS Rebel T3i handles ISO well up to 1600. Above that, noise becomes noticeable. Use noise reduction in post if needed.",
    adv_rebel_t7_advice: "Canon EOS Rebel T7 is a solid beginner DSLR. Keep ISO under 1600 for clean results. Good for learning in well-lit conditions.",
    adv_20d_advice: "Canon EOS 20D: Keep ISO as low as possible. Above 800, noise becomes very prominent. Best results in well-lit conditions.",
    adv_80d_advice: "Canon EOS 80D has a capable APS-C sensor. Comfortable up to ISO 1600, usable to 3200. Fast autofocus makes it great for action and video.",
    adv_5diii_advice: "Canon EOS 5D Mark III is a full-frame workhorse. Excellent ISO performance up to 3200, very usable at 6400. Great for low-light and professional work.",
    adv_r50_advice: "Canon EOS R50 is a modern mirrorless with excellent high-ISO performance. Comfortable up to ISO 3200, usable to 6400. Great for low-light situations.",
    adv_1dxiii_advice: "Canon EOS-1D X Mark III is the ultimate professional DSLR. 20.1MP full-frame with 20fps burst, exceptional autofocus, and unmatched high-ISO performance to 25600. Built for sports, news, and wildlife professionals.",
    adv_t8i_advice: "Canon EOS 850D/Rebel T8i is an improved beginner-to-intermediate DSLR. 24.1MP APS-C with Dual Pixel CMOS AF, 4K video, and good ISO up to 1600. A solid step up from the T7.",
    adv_90d_advice: "Canon EOS 90D packs 32.5MP into an APS-C body with 10fps burst and excellent autofocus. Good ISO to 1600, usable to 6400. Great for sports, wildlife, and landscapes.",
    adv_250d_advice: "Canon EOS 250D is one of the lightest DSLRs ever made. 24.1MP APS-C, vari-angle screen, 4K video. Best ISO up to 800. Perfect for beginners and travel.",
    adv_5div_advice: "Canon EOS 5D Mark IV is a full-frame professional workhorse. 30.4MP, excellent autofocus, 4K video, and outstanding ISO to 3200. The go-to camera for weddings, portraits, and events.",
    adv_6dii_advice: "Canon EOS 6D Mark II is an affordable full-frame option. 26.2MP, vari-angle screen, built-in GPS and Wi-Fi. Good ISO to 3200. Ideal for landscapes, travel, and portraits on a budget.",
    adv_4000d_advice: "Canon EOS 4000D is the most affordable Canon DSLR. 18MP APS-C, basic feature set. Keep ISO under 400 for clean images. A bare-bones option for absolute beginners on a tight budget.",
    adv_r3_advice: "Canon EOS R3 is a professional mirrorless flagship. 24.1MP stacked sensor with 30fps burst, eye-control AF, and exceptional ISO to 25600. Designed for sports, wildlife, and photojournalism.",
    adv_r5_advice: "Canon EOS R5/R5 II delivers 45MP full-frame resolution with IBIS, 8K video, and animal/vehicle AF tracking. Excellent ISO to 6400. The ultimate hybrid camera for professionals.",
    adv_r6_advice: "Canon EOS R6/R6 II is optimized for speed and low-light. 20-24MP full-frame with IBIS, 40fps electronic shutter, and superb ISO to 6400. Ideal all-rounder for events, portraits, and video.",
    adv_r8_advice: "Canon EOS R8 is a compact, lightweight full-frame mirrorless. 24.2MP with advanced AF and good ISO to 3200. Great entry to full-frame without the bulk.",
    adv_r7_advice: "Canon EOS R7 is Canon's top APS-C mirrorless. 32.5MP with IBIS, 15fps mechanical shutter, and excellent AF. Good ISO to 3200. Perfect for wildlife, sports, and birding.",
    adv_r10_advice: "Canon EOS R10 is a capable mid-range APS-C mirrorless. 24.2MP with fast AF, 15fps burst, and 4K video. Good ISO to 1600. Excellent value for enthusiasts.",
    adv_r100_advice: "Canon EOS R100 is the most affordable Canon mirrorless. 24.1MP APS-C, compact and simple. No IBIS or vari-angle screen. Best ISO up to 800. Ideal for budget-conscious beginners.",
    adv_eos_r_advice: "Canon EOS R was Canon's first full-frame mirrorless. 30.4MP with Dual Pixel AF and excellent image quality. Good ISO to 3200. A solid camera, especially at used prices.",
    adv_eos_rp_advice: "Canon EOS RP is the most affordable Canon full-frame mirrorless. 26.2MP, lightweight, and beginner-friendly. Good ISO to 3200. Great entry point to full-frame mirrorless photography.",
    adv_d3200_advice: "Nikon D3200 performs well up to ISO 800. Above 1600, noise increases significantly. Solid all-around APS-C sensor for good lighting.",
    adv_d3500_advice: "Nikon D3500 is a great beginner DSLR. Clean images up to ISO 800, usable to 1600. Lightweight and easy to learn on.",
    adv_d5600_advice: "Nikon D5600 has good APS-C sensor performance. Comfortable up to ISO 1600, usable to 3200. Articulating screen helps with creative angles.",
    adv_d750_advice: "Nikon D750 is a full-frame powerhouse. Excellent low-light performance up to ISO 3200, very usable at 6400. One of the best value full-frames ever made.",
    adv_p100_advice: "Nikon Coolpix P100 has a tiny 1/2.3-inch sensor. Keep ISO under 400 for best quality. Above 800, images degrade significantly. The superzoom lens is versatile but the small sensor is the limiting factor.",
    adv_d6_advice: "Nikon D6 is the ultimate professional DSLR. 20.8MP full-frame with 14fps burst, 105-point AF, and exceptional ISO to 25600. Built for sports, news, and wildlife professionals who need reliability.",
    adv_d780_advice: "Nikon D780 bridges DSLR and mirrorless with hybrid AF. 24.5MP full-frame, excellent ISO to 3200, and mirrorless-level live view AF. Great all-purpose professional camera.",
    adv_d850_advice: "Nikon D850 is a 45.7MP resolution powerhouse. Excellent dynamic range, ISO to 3200, 7fps burst, and 4K video. The go-to camera for landscapes, studio, and commercial work.",
    adv_d7500_advice: "Nikon D7500 uses the same sensor as the D500. 20.9MP APS-C with 8fps burst, tilting screen, and good ISO to 1600. Excellent enthusiast DSLR for sports and wildlife.",
    adv_z9_advice: "Nikon Z9 is the mirrorless flagship. 45.7MP stacked sensor, 120fps burst, 8K video, and no mechanical shutter. Exceptional ISO to 6400. For professionals demanding the absolute best.",
    adv_z8_advice: "Nikon Z8 puts the Z9's sensor in a smaller body. 45.7MP, exceptional AF, 8K video, and incredible ISO to 6400. Professional performance in a more portable package.",
    adv_z7ii_advice: "Nikon Z7 II delivers 45.7MP resolution with dual card slots, improved AF, and excellent ISO to 3200. Ideal for landscape, studio, and commercial photographers wanting maximum detail.",
    adv_z6iii_advice: "Nikon Z6 III has a partially stacked 24.5MP sensor for speed. Excellent ISO to 6400, fast burst, and advanced AF. The best all-around Nikon mirrorless for most photographers.",
    adv_z5_advice: "Nikon Z5 is the affordable full-frame entry. 24.3MP with IBIS, dual card slots, and good ISO to 3200. Great first full-frame camera for enthusiasts stepping up from APS-C.",
    adv_zf_advice: "Nikon Zf combines retro design with the Z6 III sensor. 24.5MP with IBIS, dedicated analog dials, and excellent ISO to 6400. A beautifully designed camera that performs as good as it looks.",
    adv_z50_advice: "Nikon Z50 is a compact APS-C mirrorless. 20.9MP with excellent AF, 4K video, and good ISO to 1600. Lightweight and perfect for travel and everyday shooting.",
    adv_zfc_advice: "Nikon Zfc is the retro-styled Z50. Same 20.9MP sensor with analog dials and classic design. Good ISO to 1600. For photographers who value aesthetics alongside performance.",
    adv_z30_advice: "Nikon Z30 is built for vlogging and content creation. 20.9MP APS-C, no viewfinder, flip-out screen. ISO moderate to 1600. Affordable video-first camera.",
    adv_a99ii_advice: "Sony A99 II is the full-frame SLT flagship. 42.4MP with 79-point AF, 12fps burst, and good ISO to 3200. The SLT mirror costs some light but enables fast phase-detect AF during video.",
    adv_a58_advice: "Sony A58 is an entry-level SLT camera. 20.1MP APS-C with translucent mirror AF. Keep ISO under 800 for clean images. An affordable way into the Sony A-mount system.",
    adv_a1_advice: "Sony A1 is the ultimate mirrorless camera. 50.1MP with 30fps burst, real-time AF tracking, 8K video, and exceptional ISO to 6400. No compromises — resolution, speed, and video in one body.",
    adv_a9iii_advice: "Sony A9 III has the world's first global shutter in a full-frame camera. 24.6MP with zero rolling shutter, 120fps burst, and excellent ISO to 6400. Revolutionary for sports and action.",
    adv_a7rv_advice: "Sony A7R V delivers 61MP with AI-based AF. Excellent detail, ISO to 3200, 8-stop IBIS, and 8K oversampled 4K. The ultimate resolution camera for landscape and studio work.",
    adv_a7iv_advice: "Sony A7 IV is the 33MP all-rounder. Excellent ISO to 6400, advanced real-time AF, 4K60, and 10fps burst. The best hybrid camera for photographers who also shoot video.",
    adv_a7siii_advice: "Sony A7S III is the low-light king. 12.1MP delivers exceptional ISO to 12800+ with minimal noise. 4K120, 16-bit RAW video. Purpose-built for video and extreme low-light shooting.",
    adv_a7cii_advice: "Sony A7C II packs the A7 IV sensor into a compact rangefinder-style body. 33MP with excellent ISO to 3200 and advanced AF. Full-frame quality in a travel-friendly size.",
    adv_zve1_advice: "Sony ZV-E1 is a full-frame vlogging camera with the A7S III sensor. 12.1MP with exceptional ISO to 12800, AI framing, and cinematic video. The best vlogging camera for low-light content.",
    adv_a6700_advice: "Sony A6700 is the top APS-C mirrorless. 26MP with AI AF, IBIS, 4K60, and good ISO to 3200. The most capable APS-C camera Sony has ever made.",
    adv_a6400_advice: "Sony A6400 remains one of the most popular APS-C cameras. 24.2MP with excellent real-time AF, 4K video, and good ISO to 1600. No IBIS but outstanding autofocus performance.",
    adv_a6100_advice: "Sony A6100 is an affordable APS-C entry point. 24.2MP with real-time AF tracking, 4K video. ISO moderate to 1600. Great value for beginners wanting advanced AF.",
    adv_zve10_advice: "Sony ZV-E10 II is an APS-C vlogging camera. 26MP with product showcase mode, directional mic, and flip screen. ISO moderate to 1600. Purpose-built for content creators on a budget.",
    adv_fx3_advice: "Sony FX3 is a cinema camera in a mirrorless body. 12.1MP A7S III sensor with exceptional ISO, active cooling, and pro video I/O. For filmmakers needing full-frame low-light cinema.",
    adv_fx30_advice: "Sony FX30 brings cinema features to APS-C. 26MP with active cooling, S-Cinetone, and good ISO to 3200. Affordable cinema camera for independent filmmakers.",
    adv_xh2_advice: "Fujifilm X-H2 delivers 40.2MP APS-C resolution. Excellent ISO to 3200, IBIS, and 8K video. For photographers and videographers who need maximum resolution from APS-C.",
    adv_xs10_advice: "Fujifilm X-S10 offers IBIS and modern controls in a compact body. 26MP with good ISO to 1600. A great mid-range option with the Fujifilm film simulation look.",
    adv_xt50_advice: "Fujifilm X-T50 is the compact 40MP camera with a dedicated film simulation dial. Good ISO to 3200. For photographers who want high resolution and the Fujifilm shooting experience.",
    adv_xe4_advice: "Fujifilm X-E4 is a minimalist rangefinder-style camera. 26MP, compact, no grip or dials for clean aesthetics. Good ISO to 1600. For street and everyday photography.",
    adv_xa7_advice: "Fujifilm X-A7 is the most affordable Fujifilm. 24.2MP with Bayer sensor (not X-Trans), large touchscreen. ISO moderate to 800. Entry-level option for beginners.",
    adv_gfx100ii_advice: "Fujifilm GFX 100 II is the medium format flagship. 102MP with phase-detect AF, IBIS, 8fps, and 8K video. Exceptional ISO to 6400. For professionals demanding the ultimate in image quality.",
    adv_gfx50sii_advice: "Fujifilm GFX 50S II makes medium format accessible. 51.4MP with IBIS, compact body, and good ISO to 1600. The most affordable way into medium format digital photography.",
    adv_s5pro_advice: "Fujifilm FinePix S5 Pro (2006) was built on a Nikon D200 body with Fuji's Super CCD sensor. Known for exceptional skin tones and dynamic range for its era. ISO limited to 400. A collector's camera.",
    adv_s3pro_advice: "Fujifilm FinePix S3 Pro (2004) used a Super CCD sensor in a Nikon F80 body. Revolutionary dynamic range for its time. ISO best under 200. A piece of digital photography history.",
    adv_k70_advice: "Pentax K-70 is weather-sealed with in-body stabilization. Good ISO performance up to 1600, usable to 6400. Great for outdoor and landscape work.",
    adv_kf_advice: "Pentax KF builds on the K-70 platform with modern updates. Good ISO performance up to 1600, usable to 6400. Weather-sealed for rugged shooting.",
    adv_a68_advice: "Sony A68 uses SLT (translucent mirror) technology with fast phase-detect AF. Keep ISO under 1600 for clean results. Good for action photography.",
    adv_a77ii_advice: "Sony A77 II is a capable SLT camera with 79-point AF system. Good ISO up to 1600, usable to 6400. Excellent for sports and wildlife with its fast burst rate.",
    adv_x100vi_advice: "Fujifilm X100VI is a premium compact with a fixed 23mm f/2 lens (35mm equiv). 40MP sensor with IBIS delivers stunning image quality. Excellent ISO to 3200, renowned film simulations. Perfect for street, travel, and everyday photography.",
    adv_xt5_advice: "Fujifilm X-T5 is a photographer's camera with 40MP sensor, IBIS, and classic analog dials. Excellent ISO to 3200, very usable at 6400. Superb for stills, landscapes, and portraits.",
    adv_xs20_advice: "Fujifilm X-S20 is a versatile hybrid camera. 26MP with IBIS, excellent battery life, and vlog-friendly features. Good ISO to 1600, usable to 6400. Great for content creators.",
    adv_xt30ii_advice: "Fujifilm X-T30 II delivers the classic Fujifilm look in a compact, affordable body. 26MP sensor, great autofocus. Good ISO to 1600. Ideal for travel and street photography.",
    adv_xh2s_advice: "Fujifilm X-H2S is a professional speed demon. Stacked 26MP sensor delivers 40fps burst, fast AF, and exceptional high ISO to 12800. Built for sports, wildlife, and high-end video.",
    adv_xm5_advice: "Fujifilm X-M5 is a compact, beginner-friendly entry point to the Fujifilm system. 26MP sensor, lightweight design. Best results up to ISO 800. Perfect for everyday shooting and learning.",
    adv_xpro3_advice: "Fujifilm X-Pro3 is a street photographer's dream. Unique hidden LCD, hybrid OVF/EVF viewfinder, and titanium build. Good ISO to 1600. Designed for those who love the shooting experience.",
    adv_gfx100s_advice: "Fujifilm GFX 100S is a medium format powerhouse. 102MP sensor delivers immense detail and dynamic range. Excellent ISO to 3200, usable to 12800. For professionals seeking the highest image quality.",
    adv_xt4_advice: "Fujifilm X-T4 was the flagship hybrid before the X-T5. 26MP with IBIS, flip screen, and fast burst. Good ISO to 1600, usable to 6400. Excellent all-rounder for stills and video.",
    adv_xt3_advice: "Fujifilm X-T3 remains a capable camera. 26MP with excellent autofocus and 4K video. Good ISO to 1600, usable to 6400. Great value on the used market.",
    adv_xt2_advice: "Fujifilm X-T2 was a game-changer for Fujifilm. 24.3MP X-Trans III sensor, weather-sealed body, dual card slots, and 4K video. Good ISO to 1600, usable to 6400. Still a very capable camera and great value used.",
    adv_xh1_advice: "Fujifilm X-H1 was the first X-series with in-body image stabilization (IBIS). 24.3MP, robust body with top LCD panel, and excellent handling. Good ISO to 1600. IBIS lets you shoot 2-3 stops slower — perfect for low-light handheld work.",
    adv_custom_advice: "Custom camera profile. Recommendations are based on the sensor type and ISO performance level you selected. Adjust settings based on your specific camera's capabilities.",

    exp_portrait: "For portrait, aperture was set first to control background blur and subject separation.",
    exp_landscape: "For landscape, aperture is locked at f/8-f/11 for edge-to-edge sharpness with ISO kept as low as possible for maximum detail.",
    exp_sports: "For sports/action, shutter speed was set first to freeze motion. Aperture opened wide to keep ISO manageable.",
    exp_macro: "For macro, aperture balanced for sufficient depth of field at close range.",
    exp_street: "For street photography, a balanced setup for quick, versatile shooting.",
    exp_wildlife: "For wildlife, shutter speed was set first to capture sharp details at distance.",
    exp_product: "For product photography, aperture set for edge-to-edge sharpness.",
    exp_event_indoor: "For events/indoor, settings balanced across aperture, shutter, and ISO for variable lighting.",
    exp_general: "A balanced combination — no single setting pushed to extremes.",
    exp_macro_lens: "With a macro lens, aperture is set to f/8-f/16 for sufficient depth of field at close focus. Shutter speed is increased to counter magnification-induced shake.",
    exp_macro_lens_tripod: "With a macro lens on tripod, we prioritize the lowest ISO and a sharper aperture for maximum detail and depth of field.",
    exp_tripod: "With tripod support, we can use slower shutter speeds for lower ISO and cleaner images.",
    exp_handheld: "For handheld, shutter speed follows the 1/(focal length x crop factor) rule.",
    exp_iso_preferred: "ISO is within the preferred range for clean images.",
    exp_iso_acceptable: "ISO is acceptable but you may notice some noise.",
    exp_iso_high: "ISO is pushed high. Use noise reduction in post-processing.",

    hist_title: "Settings History",
    hist_empty: "No saved settings yet. Calculate and save some!",
    hist_input_settings: "Input Settings",
    hist_results: "Results",
    hist_priority: "Priority Mode",
    hist_download_worksheet: "Download Shoot Planning Worksheet (PDF)",
    hist_pdf_downloaded: "Worksheet PDF downloaded!",
    res_iso_zone_label: "ISO Zone",
    hist_delete: "Delete",
    hist_confirm_delete: "Delete this entry?",

    yes: "Yes",
    no: "No",
    loading: "Loading...",
    error: "An error occurred",
    login_required: "Please sign in to use this feature",

    auth_forgot_password: "Forgot your password?",
    auth_forgot_title: "Reset Password",
    auth_forgot_subtitle: "Enter your email and we'll generate a reset link.",
    auth_send_reset: "Send Reset Link",
    auth_reset_sent: "If the email exists, a reset link is on its way (check your inbox & Spam). If it doesn't arrive, use the link shown below.",
    auth_reset_link: "Go to Reset Page",
    auth_back_to_login: "Back to login",
    auth_reset_title: "Set New Password",
    auth_new_password: "New Password",
    auth_confirm_password: "Confirm Password",
    auth_reset_btn: "Reset Password",
    auth_reset_success: "Password reset! You can now sign in.",
    auth_passwords_mismatch: "Passwords do not match",

    nav_tools: "Tools",
    nav_task_cards: "Task Cards",
    tc_title: "Task Cards",
    tc_subtitle: "Printable DSLR Advisor cheat sheets — from core camera mechanics to advanced creative genres. Tap any card to view it and download a PDF.",
    tc_open_hint: "Tap a card to view & download",
    tc_cards: "cards",
    tc_quick: "Quick Settings",
    tc_tips: "Key Tips",
    tc_remember: "Remember",
    tc_download_card: "Download PDF",
    tc_download_set: "Download full set",
    tc_generating: "Generating...",
    tc_download_sheet: "Download (8.5 × 11)",
    tc_open_sheet: "Tap a sheet to preview & download",

    rec_next_eyebrow: "Keep Learning",
    rec_next_title: "Recommended Next",

    tools_title: "Photography Tools",
    tools_subtitle: "Helpful tools for learning and quick calculations",
    tools_exposure_title: "Exposure Triangle",
    tools_exposure_desc: "Understand how aperture, shutter speed, and ISO work together.",
    tools_exposure_aperture: "Aperture controls depth of field. Wider (lower f-number) = shallower depth of field + more light.",
    tools_exposure_shutter: "Shutter speed controls motion. Faster = freezes motion but lets in less light.",
    tools_exposure_iso: "ISO controls sensor sensitivity. Higher = brighter image but more noise/grain.",
    tools_dof_title: "Depth of Field Calculator",
    tools_dof_desc: "Calculate how much of your scene will be in focus.",
    tools_dof_focal: "Focal Length (mm)",
    tools_dof_aperture: "Aperture (f/)",
    tools_dof_distance: "Subject Distance",
    tools_dof_sensor: "Sensor Size",
    tools_dof_result: "Depth of Field",
    tools_dof_near: "Near limit",
    tools_dof_far: "Far limit",
    tools_dof_total: "Total DOF",
    tools_dof_meters: "m",
    tools_dof_infinity: "Infinity",
    tools_handheld_title: "Minimum Handheld Speed",
    tools_handheld_desc: "Calculate the slowest safe shutter speed for handheld shooting.",
    tools_handheld_result: "Minimum Shutter Speed",
    tools_sunny16_title: "Sunny 16 Quick Reference",
    tools_sunny16_desc: "Classic exposure rules of thumb at ISO 100.",
    tools_sunny16_bright: "Bright Sun",
    tools_sunny16_cloudy: "Cloudy",
    tools_sunny16_shade: "Shade",
    tools_sunny16_sunset: "Sunset/Sunrise",
    tools_crop_factor: "Crop Factor",

    form_event_scenario: "Event / Shoot Scenario",
    form_primary_goal: "Primary Goal",

    event_none: "None",
    event_wedding: "Wedding",
    event_indoor_concert: "Indoor Concert",
    event_outdoor_concert: "Outdoor Concert",
    event_graduation: "Graduation Portraits",
    event_sports: "Sports Match",
    event_birthday: "Birthday Party",
    event_church: "Church Event",
    event_family: "Family Session",
    event_corporate: "Corporate Event",
    event_night_event: "Night Event",
    event_indoor_studio: "Indoor Photo Studio",
    event_outdoor_studio: "Outdoor Photo Studio",

    goal_none: "None",
    goal_portraits: "Portraits",
    goal_candid: "Candid Moments",
    goal_group: "Group Photos",
    goal_stage_action: "Stage Action",
    goal_closeups: "Close-ups",
    goal_wide_environmental: "Wide Environmental Shots",
    goal_detail_shots: "Detail Shots",

    eg_title: "Event Guidance",
    eg_lens: "Recommended Lens",
    eg_flash: "Flash",
    eg_gear: "Support Gear",
    eg_tips: "Shooting Tips",
    eg_cautions: "Cautions",

    event_wedding_lens: "24-70mm for general coverage, 70-200mm for ceremony distance, 50mm or 85mm for portraits.",
    event_wedding_flash: "Bounce flash for reception. Avoid harsh direct flash when possible.",
    event_wedding_gear: "Extra batteries, extra memory cards, speedlight with diffuser.",
    event_wedding_tips: "Be ready for changing light. Capture candid moments between posed shots. Use wider focal lengths for groups. Scout locations in advance.",
    event_wedding_cautions: "Don't miss key moments (first kiss, rings, bouquet toss). Coordinate with the wedding planner on restrictions.",

    event_indoor_concert_lens: "Fast prime (35mm or 50mm f/1.8) or telephoto zoom (70-200mm f/2.8).",
    event_indoor_concert_flash: "Usually no flash allowed. Rely on stage lighting.",
    event_indoor_concert_gear: "Extra batteries, high-capacity memory cards.",
    event_indoor_concert_tips: "Stage lighting changes quickly — protect highlights. Prioritize fast shutter speed for action. Shoot RAW for white balance flexibility.",
    event_indoor_concert_cautions: "Watch white balance under mixed stage lighting. Respect venue rules on photography.",

    event_outdoor_concert_lens: "Telephoto zoom (70-200mm) or flexible zoom (24-105mm).",
    event_outdoor_concert_flash: "Usually no flash needed during day. Not effective at distance for night.",
    event_outdoor_concert_gear: "Extra batteries, lens hood for sun protection.",
    event_outdoor_concert_tips: "Changing distance and light require flexibility. Shoot during soundcheck if possible for best access.",
    event_outdoor_concert_cautions: "Sun position shifts throughout the event. Protect gear from weather and dust.",

    event_graduation_lens: "50mm or 85mm for portraits, 24-70mm for versatility.",
    event_graduation_flash: "Fill flash outdoors if needed. Bounce flash indoors.",
    event_graduation_gear: "Reflector optional for outdoor portraits.",
    event_graduation_tips: "Use flattering focal lengths (50-85mm). Watch background distractions. Capture the diploma handoff moment.",
    event_graduation_cautions: "Ceremonies can be long — conserve battery. Seating may limit your angles.",

    event_sports_lens: "Telephoto, ideally 70-200mm f/2.8 or longer (100-400mm).",
    event_sports_flash: "Generally no flash allowed or effective at distance.",
    event_sports_gear: "Monopod for longer lenses, extra batteries, fast memory cards.",
    event_sports_tips: "Prioritize fast shutter speed (1/500+). Anticipate movement. Track action with continuous autofocus.",
    event_sports_cautions: "Outdoor lighting changes as the sun moves. Indoor arenas have challenging mixed lighting.",

    event_birthday_lens: "24-70mm or 35mm prime for tight indoor spaces.",
    event_birthday_flash: "Bounce flash off ceiling or walls for a natural look.",
    event_birthday_gear: "Extra batteries, speedlight.",
    event_birthday_tips: "Capture cake cutting, gift opening, and guest reactions. Use wider angles in small rooms.",
    event_birthday_cautions: "Indoor parties often have dim, mixed lighting. Watch for harsh shadows from direct flash.",

    event_church_lens: "Fast prime (50mm f/1.8) or 24-70mm f/2.8.",
    event_church_flash: "Use only if permitted. Silent shutter mode preferred.",
    event_church_gear: "Extra batteries. Use quiet/silent shooting mode if available.",
    event_church_tips: "Respect the event and work unobtrusively. Position yourself carefully. Use available light when possible.",
    event_church_cautions: "Flash may not be permitted. Movement and shutter noise can be disruptive.",

    event_family_lens: "50mm or 85mm for portraits, 35mm for environmental shots.",
    event_family_flash: "Natural light preferred. Fill flash for harsh outdoor shadows.",
    event_family_gear: "Reflector, extra batteries.",
    event_family_tips: "Engage with subjects for natural expressions. Shoot at child's eye level for kid photos. Golden hour provides beautiful light.",
    event_family_cautions: "Kids move unpredictably — keep shutter speed up. Watch for distracting backgrounds.",

    event_corporate_lens: "24-70mm for versatility, 70-200mm for stage and speakers.",
    event_corporate_flash: "Bounce flash for networking shots. Avoid disrupting presentations.",
    event_corporate_gear: "Extra batteries, memory cards, second camera body if available.",
    event_corporate_tips: "Capture speakers, attendees networking, venue details, and signage. Deliver images quickly.",
    event_corporate_cautions: "Professional setting — be discreet. Some presentations may restrict photography.",

    event_night_event_lens: "Fast prime preferred (35mm or 50mm f/1.4-f/1.8).",
    event_night_event_flash: "Bounce flash if appropriate. Avoid harsh direct flash.",
    event_night_event_gear: "Extra batteries (flash drains them faster), tripod if possible.",
    event_night_event_tips: "Balance blur and noise carefully. Watch color casts from mixed lighting. Use flash creatively for fill.",
    event_night_event_cautions: "High ISO will be necessary — noise is expected. Embrace it or plan for noise reduction in post.",

    event_indoor_studio_lens: "50mm or 85mm for portraits, 24-70mm for versatility, macro for product detail.",
    event_indoor_studio_flash: "Strobes or speedlights with modifiers (softbox, umbrella). Continuous LED for video or previewing light.",
    event_indoor_studio_gear: "Light stands, softboxes, reflectors, backdrops, extra batteries, tethering cable optional.",
    event_indoor_studio_tips: "Control every variable — lighting, background, subject position. Use a light meter or histogram. Shoot tethered to review on a larger screen if possible.",
    event_indoor_studio_cautions: "Watch for color casts from mixed lighting sources. Keep ISO low since you control the light. Check for unwanted reflections on glasses or shiny surfaces.",

    event_outdoor_studio_lens: "85mm or 70-200mm for portraits, 35mm or 50mm for environmental shots, 24-70mm for versatility.",
    event_outdoor_studio_flash: "Fill flash or reflector to balance harsh sun. Off-camera flash for creative lighting.",
    event_outdoor_studio_gear: "Reflector, diffuser, light stands (sandbag for wind), extra batteries, backdrops optional.",
    event_outdoor_studio_tips: "Shoot during golden hour for best natural light. Use shade or diffusers to soften harsh midday sun. Position subjects with light behind for rim lighting.",
    event_outdoor_studio_cautions: "Weather and wind can change quickly — secure gear. Direct sun causes harsh shadows and squinting. Watch background distractions in open locations.",

    goal_portraits_tip: "Use 50-85mm range for flattering perspective. Separate subject from background with a wider aperture. Look for soft, directional light.",
    goal_candid_tip: "Stay unobtrusive with a moderate focal length (35-50mm). Be ready to shoot quickly — keep camera to your eye.",
    goal_group_tip: "Use 24-35mm range for groups. Set f/5.6 or narrower to keep everyone sharp. Arrange people in staggered rows.",
    goal_stage_action_tip: "Use longest lens available. Pre-focus on key stage areas. Use continuous autofocus to track performers.",
    goal_closeups_tip: "Use 50mm+ at close distance or a macro lens. Pay attention to depth of field — even slight movement changes focus.",
    goal_wide_environmental_tip: "Use 16-35mm range. Include context and surroundings to tell the story of the event and location.",
    goal_detail_shots_tip: "Use 50-100mm range. Isolate subjects with shallow depth of field. Look for textures, patterns, and small moments.",

    nav_gear: "My Gear",
    gear_title: "My Gear Inventory",
    gear_subtitle: "Save your equipment for personalized recommendations",
    gear_cameras: "Camera Bodies",
    gear_film_cameras: "Film Cameras",
    gear_film_cameras_hint: "Analog 35mm bodies have no digital EXIF — add them here to track them in your inventory.",
    film_full_frame_tag: "Full-Frame 35mm",
    gear_lenses: "Lenses",
    gear_lighting: "Lighting",
    gear_support: "Support Gear",
    gear_add_lens: "Add Lens",
    gear_lens_name: "Lens Name",
    gear_focal_min: "Focal (mm)",
    gear_focal_max: "Max (mm)",
    gear_max_aperture: "Aperture",
    gear_optional: "Zoom",
    gear_speedlight: "Speedlight / Flash",
    gear_led_panel: "LED Panel",
    gear_strobe: "Studio Strobe",
    gear_light_meter: "Light Meter (e.g., Sekonic, Sonic)",
    gear_color_checker: "Color Checker (e.g., SpyderCHECKR, X-Rite Passport)",
    gear_tripod: "Tripod",
    gear_monopod: "Monopod",
    gear_reflector: "Reflector",
    gear_save: "Save Gear",
    gear_saved: "Gear saved!",
    gear_login_required: "Sign in to manage your gear inventory.",
    gear_no_lenses: "No lenses added yet.",
    inv_model: "Model",
    inv_serial: "Serial Number",
    inv_quantity: "Quantity",
    inv_condition: "Condition",
    inv_location: "Current Location",
    inv_purchase_date: "Purchase Date",
    inv_purchase_price: "Purchase Price",
    inv_remarks: "Remarks",
    inv_remarks_placeholder: "Any additional notes...",
    inv_download: "Download Excel",
    inv_downloaded: "Inventory downloaded!",
    inv_no_items: "No gear to export. Add items first.",
    gear_accessories: "Accessories",
    gear_accessories_hint: "Backgrounds, lighting kits, filters, bags, remotes — anything else in your kit.",
    gear_accessory_placeholder: "e.g. Softbox, ND Filter, Green Screen...",
    gear_add: "Add",
    gr_title: "From Your Gear",
    gr_ideal_label: "Ideal Setup",
    gr_empty_state: "No gear saved yet. Add your equipment to get personalized recommendations.",
    gr_best_lens: "Best Lens for This Shot",
    gr_lighting_rec: "Lighting",
    gr_support_rec: "Support Gear",
    gr_missing: "Suggested Additions",
    gr_no_lens_match: "No matching lens in your inventory for this scenario.",
    gr_reason_portrait_prime: "Ideal for portraits — fast prime creates beautiful background blur and sharp subject separation.",
    gr_reason_portrait_zoom: "Good portrait range — covers the flattering 50-85mm focal lengths.",
    gr_reason_sports_tele: "Great reach for action — telephoto lets you capture the moment from the sidelines.",
    gr_reason_sports_reach: "Usable for sports, though more reach would help capture distant action.",
    gr_reason_landscape_wide: "Wide angle captures expansive scenes with dramatic perspective and edge-to-edge detail.",
    gr_reason_landscape_general: "Suitable for landscape — captures a good portion of the scene.",
    gr_reason_macro: "Designed for close-up work — delivers the magnification and sharpness you need.",
    gr_reason_fast_aperture: "Fast aperture helps gather light and creates pleasing background separation.",
    gr_reason_versatile: "Versatile option that covers a useful focal range for this scenario.",
    gr_use_speedlight: "Use your speedlight — bounce flash recommended.",
    gr_use_led: "Your LED panel can help as continuous fill light.",
    gr_no_flash_needed: "Sufficient ambient light — no flash needed.",
    gr_use_tripod: "Use your tripod for sharper results at this shutter speed.",
    gr_use_monopod: "Your monopod can help stabilize at this shutter speed.",
    gr_no_support_needed: "Handheld shooting is fine for these settings.",
    gr_suggest_telephoto: "For sports at distance, a 70-200mm f/2.8 would let you freeze action from the sidelines.",
    gr_suggest_wide: "For landscapes, a wide-angle (16-35mm) would capture the full scene with dramatic perspective.",
    gr_suggest_fast_prime: "A fast prime like a 50mm f/1.8 would dramatically improve your low-light performance here.",
    gr_suggest_macro: "For close-up detail, a dedicated macro lens delivers magnification standard lenses can't match.",
    gr_suggest_speedlight: "A speedlight with bounce capability would give you much cleaner light indoors.",
    gr_suggest_tripod: "A tripod would let you use slower shutters for cleaner images instead of pushing ISO higher.",
    gr_suggest_monopod: "A monopod would help steady your telephoto for sharper results without the bulk of a tripod.",
    gr_suggest_portrait_prime: "A fast portrait prime (50mm or 85mm f/1.8) would give you beautiful background blur and sharper subjects.",
  },
  es: {
    nav_advisor: "Asesor",
    nav_history: "Historial",
    nav_login: "Iniciar Sesion",
    nav_register: "Registrarse",
    nav_logout: "Cerrar Sesion",
    nav_projects: "Proyectos",
    nav_careers: "Carreras",
    gear_quickfill: "Rellenar desde Tu Equipo",
    gear_my_cameras: "Mis Camaras",
    gear_my_lenses: "Mis Lentes",
    nav_guide: "Manual de Usuario",
    nav_lighting_basics: "Iluminacion Basica",
    nav_lighting: "Tecnicas de Iluminacion",
    nav_golden_hour: "Hora Dorada",
    nav_glossary: "Glosario",
    nav_studio: "Estudio",
    nav_printing: "Impresion",
    nav_learn: "Aprender",
    nav_shots: "Tipos de Planos",
    nav_calibration: "Calibracion del Monitor",
    nav_tether: "Fotografia con Tether",
    nav_histogram: "El Histograma",
    nav_metering: "Modos de Medicion",
    nav_exposure: "Compensacion de Exposicion",
    nav_cropfactor: "Factor de Recorte",
    nav_filters: "Filtros de Hardware",
    nav_compression: "Compresion de Lente",
    nav_focus: "Enfoque Avanzado",
    nav_whitebalance: "Balance de Blancos y RD",
    nav_graycard: "La Tarjeta Gris",
    nav_smartphone: "Fotografia con Smartphone",
    nav_film: "Fotografía Análoga (35mm)",
    nav_bw: "Fotografía en Blanco y Negro",
    nav_checklist: "Checklist de Preparación",
    nav_poses: "Guia de Poses",
    nav_mode_dial: "Dial de Modos",
    nav_light_meter: "Fotometro",
    nav_maintenance: "Mantenimiento y Cuidado",
    nav_anatomy: "Anatomia de la Camara",
    nav_bayer: "El Filtro Bayer",
    nav_camera_history: "Historia de la Camara",

    nav_forms: "Contratos y Formularios",

    auth_login_title: "Bienvenido",
    auth_login_subtitle: "Inicia sesion para guardar tus ajustes",
    auth_register_title: "Crear Cuenta",
    auth_register_subtitle: "Comienza a guardar tus ajustes de camara",
    auth_email: "Correo Electronico",
    auth_password: "Contrasena",
    auth_name: "Nombre Completo",
    auth_login_btn: "Iniciar Sesion",
    auth_register_btn: "Crear Cuenta",
    auth_no_account: "No tienes cuenta?",
    auth_have_account: "Ya tienes cuenta?",

    form_camera_lens: "Camara y Lente",
    form_camera: "Cuerpo de Camara",
    form_focal_length: "Distancia Focal",
    form_max_aperture: "Apertura Maxima",
    form_mm: "mm",
    form_scene: "Escena e Iluminacion",
    form_lighting_type: "Tipo de Iluminacion",
    form_light_condition: "Condicion de Luz",
    form_time_of_day: "Hora del Dia",
    form_time_of_day_hint: "Los horarios son aproximados y pueden variar segun la ubicacion y la estacion.",
    form_photo_type_title: "Tipo de Foto",
    form_options: "Opciones",
    form_tripod: "Usando Tripode",
    form_subject_movement: "Movimiento del Sujeto",
    form_depth_of_field: "Profundidad de Campo",
    form_lens_type: "Tipo de Lente",
    form_calculate: "Calcular Ajustes",
    form_calculating: "Calculando...",

    cam_canon_eos_rebel_t3i: "Canon EOS Rebel T3i",
    cam_canon_eos_rebel_t7: "Canon EOS Rebel T7 / 2000D",
    cam_canon_eos_20d: "Canon EOS 20D",
    cam_canon_eos_80d: "Canon EOS 80D",
    cam_canon_eos_5d_mark_iii: "Canon EOS 5D Mark III",
    cam_canon_eos_r50: "Canon EOS R50",
    cam_canon_eos_1dx_mark_iii: "Canon EOS-1D X Mark III",
    cam_canon_eos_rebel_t8i: "Canon EOS 850D / Rebel T8i",
    cam_canon_eos_90d: "Canon EOS 90D",
    cam_canon_eos_250d: "Canon EOS 250D / Rebel SL3",
    cam_canon_eos_5d_mark_iv: "Canon EOS 5D Mark IV",
    cam_canon_eos_6d_mark_ii: "Canon EOS 6D Mark II",
    cam_canon_eos_4000d: "Canon EOS 4000D / Rebel T100",
    cam_canon_eos_r3: "Canon EOS R3",
    cam_canon_eos_r5: "Canon EOS R5 / R5 Mark II",
    cam_canon_eos_r6: "Canon EOS R6 / R6 Mark II",
    cam_canon_eos_r8: "Canon EOS R8",
    cam_canon_eos_r7: "Canon EOS R7",
    cam_canon_eos_r10: "Canon EOS R10",
    cam_canon_eos_r100: "Canon EOS R100",
    cam_canon_eos_r: "Canon EOS R",
    cam_canon_eos_rp: "Canon EOS RP",
    cam_nikon_d3200: "Nikon D3200",
    cam_nikon_d3500: "Nikon D3500",
    cam_nikon_d5600: "Nikon D5600",
    cam_nikon_d750: "Nikon D750",
    cam_nikon_coolpix_p100: "Nikon Coolpix P100",
    cam_nikon_d6: "Nikon D6",
    cam_nikon_d780: "Nikon D780",
    cam_nikon_d850: "Nikon D850",
    cam_nikon_d7500: "Nikon D7500",
    cam_nikon_z9: "Nikon Z9",
    cam_nikon_z8: "Nikon Z8",
    cam_nikon_z7ii: "Nikon Z7 / Z7 II",
    cam_nikon_z6iii: "Nikon Z6 III",
    cam_nikon_z5: "Nikon Z5 / Z5 II",
    cam_nikon_zf: "Nikon Zf",
    cam_nikon_z50: "Nikon Z50 / Z50 II",
    cam_nikon_zfc: "Nikon Zfc",
    cam_nikon_z30: "Nikon Z30",
    cam_sony_a99ii: "Sony A99 II",
    cam_sony_a58: "Sony A58",
    cam_sony_a1: "Sony A1",
    cam_sony_a9iii: "Sony A9 III",
    cam_sony_a7rv: "Sony A7R V",
    cam_sony_a7iv: "Sony A7 IV",
    cam_sony_a7siii: "Sony A7S III",
    cam_sony_a7cii: "Sony A7C II",
    cam_sony_zve1: "Sony ZV-E1",
    cam_sony_a6700: "Sony A6700",
    cam_sony_a6400: "Sony A6400",
    cam_sony_a6100: "Sony A6100",
    cam_sony_zve10: "Sony ZV-E10 II",
    cam_sony_fx3: "Sony FX3",
    cam_sony_fx30: "Sony FX30",
    cam_fujifilm_xh2: "Fujifilm X-H2",
    cam_fujifilm_xs10: "Fujifilm X-S10",
    cam_fujifilm_xt50: "Fujifilm X-T50",
    cam_fujifilm_xe4: "Fujifilm X-E4",
    cam_fujifilm_xa7: "Fujifilm X-A7",
    cam_fujifilm_gfx100ii: "Fujifilm GFX 100 II",
    cam_fujifilm_gfx50sii: "Fujifilm GFX 50S II",
    cam_fujifilm_s5pro: "Fujifilm FinePix S5 Pro",
    cam_fujifilm_s3pro: "Fujifilm FinePix S3 Pro",
    cam_pentax_k70: "Pentax K-70",
    cam_pentax_kf: "Pentax KF",
    cam_sony_a68: "Sony A68 (SLT)",
    cam_sony_a77_ii: "Sony A77 II (SLT)",
    cam_fujifilm_x100vi: "Fujifilm X100VI",
    cam_fujifilm_xt5: "Fujifilm X-T5",
    cam_fujifilm_xs20: "Fujifilm X-S20",
    cam_fujifilm_xt30ii: "Fujifilm X-T30 II",
    cam_fujifilm_xh2s: "Fujifilm X-H2S",
    cam_fujifilm_xm5: "Fujifilm X-M5",
    cam_fujifilm_xpro3: "Fujifilm X-Pro3",
    cam_fujifilm_gfx100s: "Fujifilm GFX 100S",
    cam_fujifilm_xt4: "Fujifilm X-T4",
    cam_fujifilm_xt3: "Fujifilm X-T3",
    cam_fujifilm_xt2: "Fujifilm X-T2",
    cam_fujifilm_xh1: "Fujifilm X-H1",
    cam_custom: "Mi camara no esta en la lista",

    custom_sensor_type: "Tipo de Sensor",
    custom_iso_performance: "Rendimiento ISO",
    sensor_full_frame: "Full Frame (1.0x)",
    sensor_apsc_canon: "APS-C Canon (1.6x)",
    sensor_apsc_other: "APS-C Nikon/Pentax/Sony (1.5x)",
    sensor_micro43: "Micro Cuatro Tercios (2.0x)",
    sensor_one_inch: "Sensor de 1 pulgada (2.7x)",
    iso_perf_excellent: "Excelente (full-frame moderno)",
    iso_perf_good: "Bueno (APS-C moderno / FF antiguo)",
    iso_perf_moderate: "Moderado (APS-C tipico)",
    iso_perf_limited: "Limitado (sensor antiguo o pequeno)",

    lens_standard: "Estandar",
    lens_wide: "Gran Angular",
    lens_telephoto: "Teleobjetivo",
    lens_macro: "Macro",

    lt_natural: "Natural",
    lt_artificial: "Artificial",
    lt_mixed: "Mixta",

    lc_bright_sun: "Sol Brillante",
    lc_cloudy: "Nublado",
    lc_shade: "Sombra",
    lc_golden_hour: "Hora Dorada",
    lc_blue_hour: "Hora Azul",
    lc_indoor_window: "Interior (Ventana)",
    lc_indoor_room: "Interior (Habitacion)",
    lc_studio: "Luz de Estudio",
    lc_night_street: "Calle Nocturna",
    lc_low_light: "Poca Luz / Oscuro",

    tod_sunrise: "Amanecer (5:30 – 7:00 AM)",
    tod_morning: "Manana (7:00 – 11:00 AM)",
    tod_noon: "Mediodia (11:00 AM – 1:00 PM)",
    tod_afternoon: "Tarde (1:00 – 5:00 PM)",
    tod_sunset: "Atardecer (5:00 – 7:30 PM)",
    tod_blue_hour: "Hora Azul (antes del amanecer / despues del atardecer)",
    tod_night: "Noche (despues de 8:00 PM)",

    pt_portrait: "Retrato",
    pt_landscape: "Paisaje",
    pt_sports: "Deportes / Accion",
    pt_macro: "Macro",
    pt_street: "Callejera",
    pt_wildlife: "Vida Silvestre",
    pt_product: "Producto",
    pt_event_indoor: "Evento / Interior",
    pt_general: "General",

    mv_still: "Quieto",
    mv_slow: "Lento",
    mv_fast: "Rapido",

    dof_shallow: "Poca",
    dof_medium: "Media",
    dof_deep: "Profunda",

    res_title: "Ajustes Recomendados",
    res_aperture: "Apertura",
    res_shutter: "Velocidad de Obturacion",
    res_iso: "ISO",
    res_ev: "VE",
    res_explanation: "Por Que Estos Ajustes",
    res_warnings: "Advertencias",
    res_camera_advice: "Consejo de Camara",
    res_alternatives: "Ajustes Alternativos",
    res_balanced: "Equilibrado",
    res_balanced_desc: "Ajustes moderados, sin extremos",
    res_safer: "Mas Seguro",
    res_safer_desc: "ISO mas bajo, menos ruido",
    res_action: "Accion",
    res_action_desc: "Obturacion mas rapida",
    res_iso_zone_ideal: "Limpio",
    res_iso_zone_acceptable: "Algo de Ruido",
    res_iso_zone_caution: "Mucho Ruido",
    res_save: "Guardar en Historial",
    res_starting_note: "Estas recomendaciones son puntos de partida. Ajusta despues de tu primera toma de prueba.",
    mode_manual: "Manual",
    mode_ai: "Describe tu Toma",
    ai_title: "Describe tu Toma",
    ai_subtitle: "Dile a la IA lo que quieres fotografiar y obten un punto de partida en lenguaje sencillo.",
    ai_textarea_label: "Que quieres fotografiar?",
    ai_placeholder: "ej. Quiero fotografiar la luna llena de noche con mi Tamron 70-300mm en tripode",
    ai_examples_label: "Prueba un ejemplo",
    ai_tod_label: "Hora del dia (opcional)",
    ai_setting_label: "Ubicacion (opcional)",
    tod_sunrise: "Amanecer",
    tod_morning: "Mañana",
    tod_midday: "Mediodia",
    tod_afternoon: "Tarde",
    tod_golden: "Hora Dorada",
    tod_blue: "Hora Azul",
    tod_night: "Noche",
    set_outdoor: "Exterior",
    set_indoor: "Interior",

    ai_example_1: "Fiesta de cumpleanos en interior, poca luz, ninos corriendo",
    ai_example_2: "Retrato a la hora dorada en un parque con fondo desenfocado",
    ai_example_3: "Partido de futbol con movimiento rapido en una tarde soleada",
    ai_example_4: "Cascada sedosa de larga exposicion en un dia nublado",
    ai_submit: "Obtener Ajustes IA",
    ai_generating: "Pensando...",
    ai_gear_hint: "Tu equipo guardado se usara para recomendar el mejor objetivo.",
    ai_gear_hint_none: "Consejo: anade tu equipo en Mi Equipo para que la IA elija el mejor objetivo que tienes.",
    ai_empty_error: "Por favor describe la toma que quieres hacer.",
    ai_error: "Algo salio mal. Intentalo de nuevo.",
    ai_results_title: "Ajustes Recomendados por IA",
    ai_scene: "Escenario",
    ai_lens_label: "Objetivo Recomendado",
    ai_from_your_gear: "De tu equipo",
    ai_suggested_lens: "Tipo sugerido",
    ai_protips: "Consejos Pro",
    ai_lighting_title: "Equipo de Iluminacion",
    ai_lighting_badge: "Sugerido",
    ai_lighting_learn: "Aprende iluminacion basica",


    ai_empty_title: "Describe tu Toma",
    ai_empty: "Escribe una descripcion en lenguaje sencillo de la foto que quieres tomar y la IA sugerira un punto de partida.",
    ai_disclaimer: "Las sugerencias de IA son un punto de partida. Ajusta despues de tu primera toma de prueba.",
    ai_apply: "Aplicar al Formulario Manual",
    ai_apply_hint: "Ajusta estos valores con los controles manuales completos y guarda en el Historial.",
    ai_apply_tooltip: "Cambia a modo Manual y rellena la calculadora con la interpretacion de tu toma por la IA, para que ajustes cada control, recalcules y lo guardes en el Historial.",

    ai_applied: "Aplicado! Ajusta y presiona Calcular para guardar.",
    found_badge: "Fundamentos",
    found_title: "¿Nuevo aqui? Empieza por los fundamentos",
    found_sub: "Tres lecciones cortas que explican la camara en si — antes de sumergirte en los ajustes.",
    found_anatomy_desc: "Como funciona una camara DSLR y mirrorless",
    found_bayer_desc: "Como los sensores ven el color",
    found_history_desc: "De la camara oscura a la IA",



    res_saved: "Guardado!",
    res_empty_title: "Listo para Calcular",
    res_empty: "Configura tus ajustes y presiona Calcular para obtener recomendaciones.",

    warn_high_iso_noise: "El ISO esta por encima del rango preferido. Espera algo de ruido.",
    warn_high_iso_extreme: "El ISO esta muy por encima del limite recomendado. Ruido significativo.",
    warn_camera_iso_canon_eos_rebel_t3i: "Canon T3i: ISO por encima de 800. Usable hasta 1600, pero espera grano en sombras.",
    warn_camera_iso_canon_eos_rebel_t7: "Canon T7: ISO por encima de 800 mostrara ruido. Manten bajo 1600.",
    warn_camera_iso_canon_eos_20d: "Canon 20D: ISO alto introduce ruido visible. Manten bajo 400 para imagenes limpias — por encima de 800 se degrada mucho.",
    warn_camera_iso_canon_eos_80d: "Canon 80D: ISO por encima de 1600 mostrara algo de ruido. Usable hasta 3200 con post-procesado.",
    warn_camera_iso_canon_eos_5d_mark_iii: "5D Mark III: El sensor full-frame maneja bien ISO alto. Usable hasta 6400, cuidado con sombras sobre 3200.",
    warn_camera_iso_canon_eos_r50: "Canon R50 maneja bien ISO alto. Comoda hasta 3200, usable a 6400.",
    warn_camera_iso_canon_eos_1dx_mark_iii: "1D X Mark III: Buque insignia profesional con rendimiento ISO excepcional. Limpia hasta 6400, muy usable a 25600.",
    warn_camera_iso_canon_eos_rebel_t8i: "Canon 850D/T8i: Buen rendimiento APS-C. Limpia hasta 1600, usable a 3200. Mejora sobre Rebels anteriores.",
    warn_camera_iso_canon_eos_90d: "Canon 90D: Fuerte rendimiento APS-C. Limpia hasta 1600, usable a 6400. 32.5MP con rafaga rapida.",
    warn_camera_iso_canon_eos_250d: "Canon 250D: APS-C de entrada. Limpia hasta 800, usable a 1600. Ligera y amigable para principiantes.",
    warn_camera_iso_canon_eos_5d_mark_iv: "5D Mark IV: Caballo de batalla full-frame. ISO excelente hasta 3200, muy usable a 12800. Poca luz de grado profesional.",
    warn_camera_iso_canon_eos_6d_mark_ii: "6D Mark II: Full-frame con buen rendimiento ISO. Limpia hasta 3200, usable a 6400. Gran valor en full-frame.",
    warn_camera_iso_canon_eos_4000d: "Canon 4000D: Entrada economica. ISO mejor bajo 400, por encima de 1600 se degrada significativamente.",
    warn_camera_iso_canon_eos_r3: "EOS R3: Mirrorless profesional con sensor apilado. ISO excepcional hasta 6400, muy usable a 25600. Hecha para velocidad.",
    warn_camera_iso_canon_eos_r5: "EOS R5: Full-frame de 45MP. ISO excelente hasta 6400, muy usable a 12800. Resolucion y poca luz excepcionales.",
    warn_camera_iso_canon_eos_r6: "EOS R6: Full-frame de 20MP optimizada para poca luz. ISO excelente hasta 6400, muy usable a 12800. IBIS ayuda aun mas.",
    warn_camera_iso_canon_eos_r8: "EOS R8: Full-frame compacta. Buen ISO hasta 3200, muy usable a 12800. Ligera pero sensor capaz.",
    warn_camera_iso_canon_eos_r7: "EOS R7: APS-C mirrorless de gama alta. Limpia hasta 3200, usable a 6400. IBIS y rafaga rapida para accion.",
    warn_camera_iso_canon_eos_r10: "EOS R10: APS-C mirrorless de gama media. Limpia hasta 1600, usable a 6400. Excelente enfoque por su precio.",
    warn_camera_iso_canon_eos_r100: "EOS R100: Mirrorless economica. Limpia hasta 800, usable a 1600. Sin IBIS — manten velocidad rapida.",
    warn_camera_iso_canon_eos_r: "EOS R: Mirrorless full-frame original. Limpia hasta 3200, usable a 6400. Solido rendimiento en buenas condiciones.",
    warn_camera_iso_canon_eos_rp: "EOS RP: Mirrorless full-frame de entrada. Limpia hasta 3200, usable a 6400. Opcion full-frame accesible.",
    warn_camera_iso_nikon_d3200: "Nikon D3200: ISO por encima de 800 muestra ruido notable. Manten bajo 800 cuando sea posible.",
    warn_camera_iso_nikon_d3500: "Nikon D3500: ISO por encima de 800 mostrara ruido. Limpia hasta 800, usable a 1600.",
    warn_camera_iso_nikon_d5600: "Nikon D5600: ISO por encima de 1600 muestra algo de ruido. Buena hasta 3200 con cuidado.",
    warn_camera_iso_nikon_d750: "Nikon D750: Full-frame maneja muy bien ISO alto. Limpia hasta 3200, usable a 6400.",
    warn_camera_iso_nikon_coolpix_p100: "Coolpix P100: Sensor pequeno produce ruido significativo por encima de ISO 400. Manten lo mas bajo posible.",
    warn_camera_iso_nikon_d6: "Nikon D6: Buque insignia profesional. ISO excepcional hasta 6400, usable a 25600.",
    warn_camera_iso_nikon_d780: "Nikon D780: Full-frame todoterreno. ISO excelente hasta 3200, muy usable a 12800.",
    warn_camera_iso_nikon_d850: "Nikon D850: 45.7MP full-frame. ISO excelente hasta 3200, usable a 12800.",
    warn_camera_iso_nikon_d7500: "Nikon D7500: APS-C entusiasta. Buen ISO hasta 1600, usable a 6400.",
    warn_camera_iso_nikon_z9: "Nikon Z9: Buque insignia mirrorless profesional. ISO excepcional hasta 6400, usable a 25600.",
    warn_camera_iso_nikon_z8: "Nikon Z8: Mismo sensor que Z9 en cuerpo menor. ISO excepcional hasta 6400, usable a 25600.",
    warn_camera_iso_nikon_z7ii: "Nikon Z7 II: 45.7MP full-frame. ISO excelente hasta 3200, usable a 12800.",
    warn_camera_iso_nikon_z6iii: "Nikon Z6 III: Sensor parcialmente apilado. ISO excelente hasta 6400, usable a 12800.",
    warn_camera_iso_nikon_z5: "Nikon Z5: Full-frame de entrada. Buen ISO hasta 3200, usable a 6400. IBIS incluido.",
    warn_camera_iso_nikon_zf: "Nikon Zf: Full-frame retro con sensor moderno. ISO excelente hasta 6400, usable a 12800.",
    warn_camera_iso_nikon_z50: "Nikon Z50: APS-C mirrorless compacta. Buen ISO hasta 1600, usable a 6400.",
    warn_camera_iso_nikon_zfc: "Nikon Zfc: APS-C mirrorless retro. Buen ISO hasta 1600, usable a 6400.",
    warn_camera_iso_nikon_z30: "Nikon Z30: APS-C para vlogging. ISO moderado hasta 1600, usable a 3200. Sin IBIS ni visor.",
    warn_camera_iso_sony_a99ii: "Sony A99 II: Full-frame SLT. Buen ISO hasta 3200, usable a 6400. 42MP con espejo SLT.",
    warn_camera_iso_sony_a58: "Sony A58: SLT de entrada. ISO moderado hasta 800, usable a 1600. Mejor con buena luz.",
    warn_camera_iso_sony_a1: "Sony A1: Buque insignia de 50MP. ISO excepcional hasta 6400, usable a 25600. 30fps con AF completo.",
    warn_camera_iso_sony_a9iii: "Sony A9 III: Obturador global para deportes. ISO excelente hasta 6400, usable a 12800.",
    warn_camera_iso_sony_a7rv: "Sony A7R V: 61MP full-frame. ISO excelente hasta 3200, usable a 12800. AF basado en IA.",
    warn_camera_iso_sony_a7iv: "Sony A7 IV: 33MP full-frame todoterreno. ISO excelente hasta 6400, usable a 12800.",
    warn_camera_iso_sony_a7siii: "Sony A7S III: 12MP especialista en video. ISO excepcional hasta 12800, usable a 25600.",
    warn_camera_iso_sony_a7cii: "Sony A7C II: Full-frame compacta. ISO excelente hasta 3200, usable a 12800.",
    warn_camera_iso_sony_zve1: "Sony ZV-E1: Full-frame para vlogging. ISO excepcional hasta 12800. Sensor A7S III en cuerpo vlog.",
    warn_camera_iso_sony_a6700: "Sony A6700: APS-C mirrorless tope. Buen ISO hasta 3200, usable a 6400. AF con IA e IBIS.",
    warn_camera_iso_sony_a6400: "Sony A6400: APS-C popular con excelente AF. Buen ISO hasta 1600, usable a 6400. Sin IBIS.",
    warn_camera_iso_sony_a6100: "Sony A6100: APS-C mirrorless de entrada. ISO moderado hasta 1600, usable a 3200.",
    warn_camera_iso_sony_zve10: "Sony ZV-E10 II: APS-C para vlogging. ISO moderado hasta 1600, usable a 3200.",
    warn_camera_iso_sony_fx3: "Sony FX3: Cine full-frame. ISO excepcional hasta 12800. Sensor A7S III para produccion de video.",
    warn_camera_iso_sony_fx30: "Sony FX30: Cine APS-C. Buen ISO hasta 3200, usable a 6400. Video profesional en sensor crop.",
    warn_camera_iso_fujifilm_xh2: "Fujifilm X-H2: APS-C de 40MP. ISO excelente hasta 3200, usable a 6400. Maxima resolucion.",
    warn_camera_iso_fujifilm_xs10: "Fujifilm X-S10: APS-C de gama media con IBIS. Buen ISO hasta 1600, usable a 6400.",
    warn_camera_iso_fujifilm_xt50: "Fujifilm X-T50: APS-C compacta de 40MP. Buen ISO hasta 3200, usable a 6400.",
    warn_camera_iso_fujifilm_xe4: "Fujifilm X-E4: Estilo telemetro minimalista. Buen ISO hasta 1600, usable a 6400.",
    warn_camera_iso_fujifilm_xa7: "Fujifilm X-A7: APS-C de entrada. ISO moderado hasta 800, usable a 1600. Sensor Bayer.",
    warn_camera_iso_fujifilm_gfx100ii: "GFX 100 II: Buque insignia formato medio 102MP. ISO excepcional hasta 6400, usable a 12800.",
    warn_camera_iso_fujifilm_gfx50sii: "GFX 50S II: Formato medio de 51MP. Buen ISO hasta 1600, usable a 6400.",
    warn_camera_iso_fujifilm_s5pro: "FinePix S5 Pro: Super CCD legacy. ISO limitado hasta 400, usable a 800. Tonos de piel excepcionales.",
    warn_camera_iso_fujifilm_s3pro: "FinePix S3 Pro: Super CCD legacy. ISO limitado — mejor bajo 200, usable a 400. Montura Nikon F.",
    warn_camera_iso_pentax_k70: "Pentax K-70: ISO por encima de 1600 muestra algo de ruido. La estabilizacion ayuda a mantener ISO bajo.",
    warn_camera_iso_pentax_kf: "Pentax KF: ISO por encima de 1600 muestra algo de ruido. Usa estabilizacion para bajar el ISO.",
    warn_camera_iso_sony_a68: "Sony A68: ISO por encima de 1600 introduce ruido visible. Manten bajo 1600.",
    warn_camera_iso_sony_a77_ii: "Sony A77 II: Buena hasta ISO 1600, usable a 6400. El espejo SLT cuesta aproximadamente 1/3 de paso de luz.",
    warn_camera_iso_fujifilm_x100vi: "Fujifilm X100VI: Excelente rendimiento ISO. Limpia hasta 3200, muy usable a 6400. Sensor de 40MP con IBIS.",
    warn_camera_iso_fujifilm_xt5: "Fujifilm X-T5: Excelente sensor de 40MP. Limpia hasta ISO 3200, muy usable a 6400. IBIS ayuda a mantener ISO bajo.",
    warn_camera_iso_fujifilm_xs20: "Fujifilm X-S20: Buen rendimiento ISO. Limpia hasta 1600, usable a 6400. IBIS y excelente bateria.",
    warn_camera_iso_fujifilm_xt30ii: "Fujifilm X-T30 II: Buen rendimiento ISO. Limpia hasta 1600, usable a 6400. Compacta y portatil.",
    warn_camera_iso_fujifilm_xh2s: "Fujifilm X-H2S: Sensor apilado excelente en ISO alto. Limpia hasta 3200, muy usable a 12800. Hecha para velocidad.",
    warn_camera_iso_fujifilm_xm5: "Fujifilm X-M5: Rendimiento ISO de entrada. Limpia hasta 800, usable a 3200. Mejores resultados con buena luz.",
    warn_camera_iso_fujifilm_xpro3: "Fujifilm X-Pro3: Buen rendimiento ISO. Limpia hasta 1600, usable a 6400. Visor hibrido unico.",
    warn_camera_iso_fujifilm_gfx100s: "Fujifilm GFX 100S: Sensor de formato medio maneja ISO excepcionalmente. Limpia hasta 3200, usable a 12800.",
    warn_camera_iso_fujifilm_xt4: "Fujifilm X-T4: Buen rendimiento ISO. Limpia hasta 1600, usable a 6400. IBIS y rafaga rapida.",
    warn_camera_iso_fujifilm_xt3: "Fujifilm X-T3: Buen rendimiento ISO. Limpia hasta 1600, usable a 6400. Excelente sistema de enfoque.",
    warn_camera_iso_fujifilm_xt2: "Fujifilm X-T2: Buen rendimiento ISO. Limpia hasta 1600, usable a 6400. Sensor X-Trans III de 24MP con doble ranura.",
    warn_camera_iso_fujifilm_xh1: "Fujifilm X-H1: Buen rendimiento ISO. Limpia hasta 1600, usable a 6400. Primera X-series con IBIS — ayuda a mantener ISO bajo.",
    warn_camera_iso_custom: "Camara personalizada: ISO por encima del rango preferido para tu nivel de rendimiento seleccionado.",
    warn_motion_blur_risk: "La velocidad puede ser muy lenta sin tripode. Riesgo de desenfoque.",
    warn_tripod_recommended: "Se recomienda un tripode a esta velocidad.",
    warn_macro_tripod_warning: "La macro se beneficia de la estabilidad del tripode.",
    warn_macro_shallow_dof: "La fotografia macro tiene profundidad de campo extremadamente reducida a corta distancia.",
    warn_macro_handheld_blur: "La macro sin tripode aumenta significativamente el riesgo de desenfoque por la magnificacion.",
    warn_macro_consider_light: "Considera usar un anillo de luz, flash u otra iluminacion adicional para macro.",
    warn_consider_flash: "Considera usar flash o iluminacion adicional.",
    warn_tripod_would_help: "Un tripode permitiria ISO mas bajo para imagenes significativamente mas limpias con esta luz.",
    warn_low_light_challenging: "Condiciones de poca luz. La calidad puede verse afectada.",
    warn_exposure_limited: "El ISO esta al limite. La imagen puede estar subexpuesta.",

    adv_t3i_advice: "La Canon EOS Rebel T3i maneja bien el ISO hasta 1600. Por encima, el ruido es notorio.",
    adv_rebel_t7_advice: "La Canon EOS Rebel T7 es una buena DSLR para principiantes. Manten ISO bajo 1600 para resultados limpios.",
    adv_20d_advice: "Canon EOS 20D: Manten el ISO lo mas bajo posible. Por encima de 800, el ruido es muy prominente.",
    adv_80d_advice: "La Canon EOS 80D tiene un sensor APS-C capaz. Comoda hasta ISO 1600, usable a 3200. Excelente enfoque para accion.",
    adv_5diii_advice: "La Canon EOS 5D Mark III es un caballo de batalla full-frame. Excelente ISO hasta 3200, muy usable a 6400.",
    adv_r50_advice: "La Canon EOS R50 es una mirrorless moderna con excelente rendimiento en ISO alto. Comoda hasta ISO 3200, usable hasta 6400.",
    adv_1dxiii_advice: "La Canon EOS-1D X Mark III es la DSLR profesional definitiva. 20.1MP full-frame con rafaga de 20fps, enfoque excepcional y rendimiento ISO inigualable hasta 25600. Para profesionales de deportes y noticias.",
    adv_t8i_advice: "La Canon EOS 850D/Rebel T8i es una DSLR mejorada de nivel intermedio. 24.1MP APS-C con Dual Pixel AF, video 4K y buen ISO hasta 1600. Un paso adelante del T7.",
    adv_90d_advice: "La Canon EOS 90D tiene 32.5MP en cuerpo APS-C con rafaga de 10fps y excelente enfoque. Buen ISO hasta 1600, usable a 6400. Genial para deportes, fauna y paisajes.",
    adv_250d_advice: "La Canon EOS 250D es una de las DSLR mas ligeras jamas hechas. 24.1MP APS-C, pantalla articulada, video 4K. Mejor ISO hasta 800. Perfecta para principiantes y viajes.",
    adv_5div_advice: "La Canon EOS 5D Mark IV es un caballo de batalla full-frame profesional. 30.4MP, excelente enfoque, video 4K y ISO excepcional hasta 3200. La camara preferida para bodas, retratos y eventos.",
    adv_6dii_advice: "La Canon EOS 6D Mark II es una opcion full-frame accesible. 26.2MP, pantalla articulada, GPS y Wi-Fi. Buen ISO hasta 3200. Ideal para paisajes, viajes y retratos con presupuesto.",
    adv_4000d_advice: "La Canon EOS 4000D es la DSLR Canon mas economica. 18MP APS-C, funciones basicas. Manten ISO bajo 400. Opcion basica para principiantes con presupuesto muy limitado.",
    adv_r3_advice: "La Canon EOS R3 es el buque insignia mirrorless profesional. Sensor apilado de 24.1MP con rafaga de 30fps, AF con control ocular y ISO excepcional hasta 25600. Para deportes, fauna y fotoperiodismo.",
    adv_r5_advice: "La Canon EOS R5/R5 II ofrece 45MP full-frame con IBIS, video 8K y seguimiento AF de animales/vehiculos. ISO excelente hasta 6400. La camara hibrida definitiva para profesionales.",
    adv_r6_advice: "La Canon EOS R6/R6 II esta optimizada para velocidad y poca luz. 20-24MP full-frame con IBIS, obturador electronico de 40fps y ISO magnifico hasta 6400. Todo terreno ideal.",
    adv_r8_advice: "La Canon EOS R8 es una mirrorless full-frame compacta y ligera. 24.2MP con AF avanzado y buen ISO hasta 3200. Gran entrada al full-frame sin el peso.",
    adv_r7_advice: "La Canon EOS R7 es la mejor APS-C mirrorless de Canon. 32.5MP con IBIS, obturador mecanico de 15fps y excelente AF. Buen ISO hasta 3200. Perfecta para fauna, deportes y aves.",
    adv_r10_advice: "La Canon EOS R10 es una APS-C mirrorless capaz de gama media. 24.2MP con AF rapido, rafaga de 15fps y video 4K. Buen ISO hasta 1600. Excelente valor para entusiastas.",
    adv_r100_advice: "La Canon EOS R100 es la mirrorless Canon mas economica. 24.1MP APS-C, compacta y simple. Sin IBIS ni pantalla articulada. Mejor ISO hasta 800. Ideal para principiantes con presupuesto.",
    adv_eos_r_advice: "La Canon EOS R fue la primera mirrorless full-frame de Canon. 30.4MP con Dual Pixel AF y excelente calidad de imagen. Buen ISO hasta 3200. Solida camara, especialmente a precios de segunda mano.",
    adv_eos_rp_advice: "La Canon EOS RP es la mirrorless full-frame Canon mas accesible. 26.2MP, ligera y amigable. Buen ISO hasta 3200. Gran punto de entrada a la fotografia full-frame mirrorless.",
    adv_d3200_advice: "La Nikon D3200 rinde bien hasta ISO 800. Por encima de 1600, el ruido aumenta significativamente.",
    adv_d3500_advice: "La Nikon D3500 es excelente para principiantes. Limpia hasta ISO 800, usable hasta 1600.",
    adv_d5600_advice: "La Nikon D5600 tiene buen rendimiento APS-C. Comoda hasta ISO 1600, usable a 3200.",
    adv_d750_advice: "La Nikon D750 es una potencia full-frame. Excelente en poca luz hasta ISO 3200, muy usable a 6400.",
    adv_p100_advice: "La Nikon Coolpix P100 tiene un sensor muy pequeno (1/2.3 pulgadas). Manten el ISO bajo 400. Por encima de 800, la calidad se degrada mucho.",
    adv_d6_advice: "La Nikon D6 es la DSLR profesional definitiva. 20.8MP full-frame con rafaga de 14fps y ISO excepcional hasta 25600. Para profesionales de deportes y noticias.",
    adv_d780_advice: "La Nikon D780 combina DSLR y mirrorless con AF hibrido. 24.5MP full-frame, ISO excelente hasta 3200. Gran camara todoterreno profesional.",
    adv_d850_advice: "La Nikon D850 es una potencia de resolucion de 45.7MP. Excelente rango dinamico, ISO hasta 3200. Ideal para paisajes, estudio y trabajo comercial.",
    adv_d7500_advice: "La Nikon D7500 usa el mismo sensor que la D500. 20.9MP APS-C con rafaga de 8fps. Buen ISO hasta 1600. Excelente para deportes y fauna.",
    adv_z9_advice: "La Nikon Z9 es el buque insignia mirrorless. 45.7MP con sensor apilado, rafaga de 120fps y video 8K. ISO excepcional hasta 6400.",
    adv_z8_advice: "La Nikon Z8 pone el sensor de la Z9 en un cuerpo menor. 45.7MP, AF excepcional y video 8K. ISO increible hasta 6400.",
    adv_z7ii_advice: "La Nikon Z7 II ofrece 45.7MP con doble ranura, AF mejorado y ISO excelente hasta 3200. Ideal para paisajes y estudio.",
    adv_z6iii_advice: "La Nikon Z6 III tiene sensor parcialmente apilado de 24.5MP. ISO excelente hasta 6400 y AF avanzado. La mejor Nikon mirrorless todoterreno.",
    adv_z5_advice: "La Nikon Z5 es la entrada full-frame accesible. 24.3MP con IBIS y buen ISO hasta 3200. Gran primera full-frame para entusiastas.",
    adv_zf_advice: "La Nikon Zf combina diseno retro con el sensor de la Z6 III. 24.5MP con IBIS y diales analogicos. ISO excelente hasta 6400. Hermosa y capaz.",
    adv_z50_advice: "La Nikon Z50 es una APS-C mirrorless compacta. 20.9MP con excelente AF y buen ISO hasta 1600. Ligera y perfecta para viajes.",
    adv_zfc_advice: "La Nikon Zfc es la Z50 con estilo retro. Mismo sensor de 20.9MP con diales analogicos. Buen ISO hasta 1600.",
    adv_z30_advice: "La Nikon Z30 esta disenada para vlogging. 20.9MP APS-C sin visor, pantalla abatible. ISO moderado hasta 1600.",
    adv_a99ii_advice: "La Sony A99 II es el buque insignia SLT full-frame. 42.4MP con AF de 79 puntos y buen ISO hasta 3200. El espejo SLT cuesta algo de luz pero permite AF rapido.",
    adv_a58_advice: "La Sony A58 es una SLT de entrada. 20.1MP APS-C. Manten ISO bajo 800. Opcion accesible para el sistema Sony A-mount.",
    adv_a1_advice: "La Sony A1 es la mirrorless definitiva. 50.1MP con rafaga de 30fps, AF en tiempo real y video 8K. ISO excepcional hasta 6400. Sin compromisos.",
    adv_a9iii_advice: "La Sony A9 III tiene el primer obturador global del mundo en full-frame. 24.6MP sin distorsion rolling shutter y rafaga de 120fps. ISO excelente hasta 6400.",
    adv_a7rv_advice: "La Sony A7R V ofrece 61MP con AF basado en IA. Detalle excelente, ISO hasta 3200 y IBIS de 8 pasos. Para paisajes y estudio.",
    adv_a7iv_advice: "La Sony A7 IV es la todoterreno de 33MP. ISO excelente hasta 6400, AF avanzado y video 4K60. La mejor hibrida para foto y video.",
    adv_a7siii_advice: "La Sony A7S III es el rey de poca luz. 12.1MP con ISO excepcional hasta 12800+ con minimo ruido. Construida para video y poca luz extrema.",
    adv_a7cii_advice: "La Sony A7C II pone el sensor del A7 IV en un cuerpo compacto estilo telemetro. 33MP con ISO excelente hasta 3200. Full-frame en tamano de viaje.",
    adv_zve1_advice: "La Sony ZV-E1 es una full-frame para vlogging con sensor del A7S III. 12.1MP con ISO excepcional hasta 12800. La mejor camara vlog para poca luz.",
    adv_a6700_advice: "La Sony A6700 es la mejor APS-C mirrorless de Sony. 26MP con AF de IA, IBIS y buen ISO hasta 3200. La APS-C mas capaz de Sony.",
    adv_a6400_advice: "La Sony A6400 sigue siendo una de las APS-C mas populares. 24.2MP con excelente AF en tiempo real y buen ISO hasta 1600. Sin IBIS pero AF excepcional.",
    adv_a6100_advice: "La Sony A6100 es un punto de entrada APS-C accesible. 24.2MP con AF en tiempo real. ISO moderado hasta 1600. Gran valor para principiantes.",
    adv_zve10_advice: "La Sony ZV-E10 II es una APS-C para vlogging. 26MP con modo showcase de producto y pantalla abatible. ISO moderado hasta 1600.",
    adv_fx3_advice: "La Sony FX3 es una camara de cine en cuerpo mirrorless. Sensor A7S III con ISO excepcional, enfriamiento activo y conectores profesionales.",
    adv_fx30_advice: "La Sony FX30 trae funciones de cine a APS-C. 26MP con enfriamiento activo, S-Cinetone y buen ISO hasta 3200. Cine accesible para cineastas independientes.",
    adv_xh2_advice: "La Fujifilm X-H2 ofrece 40.2MP de resolucion APS-C. ISO excelente hasta 3200, IBIS y video 8K. Maxima resolucion del sistema APS-C.",
    adv_xs10_advice: "La Fujifilm X-S10 ofrece IBIS y controles modernos en cuerpo compacto. 26MP con buen ISO hasta 1600. Gran opcion de gama media con el look Fujifilm.",
    adv_xt50_advice: "La Fujifilm X-T50 es la camara compacta de 40MP con dial de simulacion de pelicula. Buen ISO hasta 3200. Para fotografos que quieren resolucion y experiencia Fujifilm.",
    adv_xe4_advice: "La Fujifilm X-E4 es una camara estilo telemetro minimalista. 26MP, compacta y elegante. Buen ISO hasta 1600. Para fotografia callejera y cotidiana.",
    adv_xa7_advice: "La Fujifilm X-A7 es la mas accesible de Fujifilm. 24.2MP con sensor Bayer, pantalla tactil grande. ISO moderado hasta 800. Opcion de entrada para principiantes.",
    adv_gfx100ii_advice: "La Fujifilm GFX 100 II es el buque insignia de formato medio. 102MP con AF por deteccion de fase, IBIS y video 8K. ISO excepcional hasta 6400.",
    adv_gfx50sii_advice: "La Fujifilm GFX 50S II hace accesible el formato medio. 51.4MP con IBIS y buen ISO hasta 1600. La forma mas accesible de entrar al formato medio digital.",
    adv_s5pro_advice: "La Fujifilm FinePix S5 Pro (2006) fue construida sobre un cuerpo Nikon D200. Conocida por tonos de piel excepcionales. ISO limitado a 400. Camara de coleccion.",
    adv_s3pro_advice: "La Fujifilm FinePix S3 Pro (2004) uso un sensor Super CCD en cuerpo Nikon F80. Rango dinamico revolucionario para su epoca. ISO mejor bajo 200.",
    adv_k70_advice: "La Pentax K-70 es resistente al clima con estabilizacion integrada. Buen ISO hasta 1600, usable a 6400.",
    adv_kf_advice: "La Pentax KF mejora la plataforma K-70. Buen ISO hasta 1600, usable a 6400. Resistente al clima.",
    adv_a68_advice: "La Sony A68 usa tecnologia SLT con enfoque rapido. Manten ISO bajo 1600 para resultados limpios.",
    adv_a77ii_advice: "La Sony A77 II tiene sistema AF de 79 puntos. Buen ISO hasta 1600, usable a 6400. Excelente para deportes.",
    adv_x100vi_advice: "La Fujifilm X100VI es una compacta premium con lente fijo 23mm f/2 (equiv 35mm). Sensor de 40MP con IBIS y simulaciones de pelicula legendarias. ISO excelente hasta 3200. Perfecta para calle, viajes y fotografia cotidiana.",
    adv_xt5_advice: "La Fujifilm X-T5 es una camara de fotografo con sensor de 40MP, IBIS y diales analogicos clasicos. ISO excelente hasta 3200, muy usable a 6400. Magnifica para stills, paisajes y retratos.",
    adv_xs20_advice: "La Fujifilm X-S20 es una camara hibrida versatil. 26MP con IBIS, excelente bateria y funciones para vlogging. Buen ISO hasta 1600. Ideal para creadores de contenido.",
    adv_xt30ii_advice: "La Fujifilm X-T30 II ofrece el look clasico Fujifilm en un cuerpo compacto y accesible. Sensor de 26MP, buen enfoque. ISO bueno hasta 1600. Ideal para viajes y calle.",
    adv_xh2s_advice: "La Fujifilm X-H2S es un buque insignia profesional de velocidad. Sensor apilado de 26MP con rafaga de 40fps, AF rapido y excelente ISO hasta 12800. Para deportes, fauna y video de alto nivel.",
    adv_xm5_advice: "La Fujifilm X-M5 es una entrada compacta y amigable al sistema Fujifilm. Sensor de 26MP, diseno ligero. Mejores resultados hasta ISO 800. Perfecta para uso cotidiano y aprendizaje.",
    adv_xpro3_advice: "La Fujifilm X-Pro3 es el sueno del fotografo callejero. LCD oculto unico, visor hibrido OVF/EVF y construccion en titanio. Buen ISO hasta 1600. Disenada para quienes aman la experiencia de disparar.",
    adv_gfx100s_advice: "La Fujifilm GFX 100S es una potencia de formato medio. Sensor de 102MP con detalle y rango dinamico inmensos. ISO excelente hasta 3200, usable a 12800. Para profesionales que buscan la maxima calidad.",
    adv_xt4_advice: "La Fujifilm X-T4 fue la insignia hibrida antes de la X-T5. 26MP con IBIS, pantalla abatible y rafaga rapida. Buen ISO hasta 1600. Excelente todo terreno para fotos y video.",
    adv_xt3_advice: "La Fujifilm X-T3 sigue siendo una camara capaz. 26MP con excelente enfoque y video 4K. Buen ISO hasta 1600. Gran valor en el mercado de segunda mano.",
    adv_xt2_advice: "La Fujifilm X-T2 fue un cambio de juego para Fujifilm. 24.3MP con sensor X-Trans III, cuerpo sellado, doble ranura y video 4K. Buen ISO hasta 1600. Sigue siendo muy capaz y gran valor de segunda mano.",
    adv_xh1_advice: "La Fujifilm X-H1 fue la primera X-series con estabilizacion en cuerpo (IBIS). 24.3MP, cuerpo robusto con LCD superior y excelente manejo. Buen ISO hasta 1600. IBIS permite disparar 2-3 pasos mas lento.",
    adv_custom_advice: "Perfil de camara personalizado. Las recomendaciones se basan en el tipo de sensor y nivel ISO que seleccionaste.",

    exp_portrait: "Para retrato, la apertura se ajusta primero para controlar el desenfoque de fondo y la separacion del sujeto.",
    exp_landscape: "Para paisaje, la apertura se fija en f/8-f/11 para nitidez total con ISO lo mas bajo posible para maximo detalle.",
    exp_sports: "Para deportes, la velocidad de obturacion se ajusta primero para congelar el movimiento. Apertura abierta para manejar el ISO.",
    exp_macro: "Para macro, apertura equilibrada para profundidad de campo suficiente.",
    exp_street: "Para callejera, configuracion equilibrada para disparos rapidos y versatiles.",
    exp_wildlife: "Para vida silvestre, la velocidad se ajusta primero para detalles nitidos a distancia.",
    exp_product: "Para producto, apertura ajustada para nitidez de borde a borde.",
    exp_event_indoor: "Para eventos, ajustes equilibrados entre apertura, velocidad e ISO para iluminacion variable.",
    exp_general: "Combinacion equilibrada — ningun ajuste llevado al extremo.",
    exp_macro_lens: "Con lente macro, la apertura se ajusta a f/8-f/16 para profundidad de campo suficiente a corta distancia. La velocidad aumenta para contrarrestar la vibracion por magnificacion.",
    exp_macro_lens_tripod: "Con lente macro en tripode, priorizamos el ISO mas bajo y una apertura optima para maximo detalle y profundidad de campo.",
    exp_tripod: "Con tripode, podemos usar velocidades mas lentas para menor ISO.",
    exp_handheld: "Sin tripode, la velocidad sigue la regla 1/(focal x factor de recorte).",
    exp_iso_preferred: "El ISO esta en el rango preferido para imagenes limpias.",
    exp_iso_acceptable: "El ISO es aceptable pero puedes notar algo de ruido.",
    exp_iso_high: "El ISO esta alto. Usa reduccion de ruido en postprocesamiento.",

    hist_title: "Historial de Ajustes",
    hist_empty: "Sin ajustes guardados. Calcula y guarda algunos!",
    hist_input_settings: "Ajustes de Entrada",
    hist_results: "Resultados",
    hist_priority: "Modo Prioritario",
    hist_download_worksheet: "Descargar Hoja de Planificacion (PDF)",
    hist_pdf_downloaded: "PDF de hoja de trabajo descargado!",
    res_iso_zone_label: "Zona ISO",
    hist_delete: "Eliminar",
    hist_confirm_delete: "Eliminar esta entrada?",

    yes: "Si",
    no: "No",
    loading: "Cargando...",
    error: "Ocurrio un error",
    login_required: "Inicia sesion para usar esta funcion",

    auth_forgot_password: "Olvidaste tu contrasena?",
    auth_forgot_title: "Restablecer Contrasena",
    auth_forgot_subtitle: "Ingresa tu correo y generaremos un enlace de restablecimiento.",
    auth_send_reset: "Enviar Enlace",
    auth_reset_sent: "Si existe la cuenta, te enviamos un enlace de restablecimiento (revisa tu Bandeja y Spam). Si no llega, usa el enlace que aparece abajo.",
    auth_reset_link: "Ir a Restablecer",
    auth_back_to_login: "Volver al inicio de sesion",
    auth_reset_title: "Nueva Contrasena",
    auth_new_password: "Nueva Contrasena",
    auth_confirm_password: "Confirmar Contrasena",
    auth_reset_btn: "Restablecer Contrasena",
    auth_reset_success: "Contrasena restablecida! Ya puedes iniciar sesion.",
    auth_passwords_mismatch: "Las contrasenas no coinciden",

    nav_tools: "Herramientas",
    nav_task_cards: "Task Cards",
    tc_title: "Task Cards",
    tc_subtitle: "Hojas de referencia DSLR Advisor imprimibles — desde la mecanica basica de la camara hasta generos creativos avanzados. Toca cualquier tarjeta para verla y descargar un PDF.",
    tc_open_hint: "Toca una tarjeta para ver y descargar",
    tc_cards: "tarjetas",
    tc_quick: "Ajustes Rapidos",
    tc_tips: "Consejos Clave",
    tc_remember: "Recuerda",
    tc_download_card: "Descargar PDF",
    tc_download_set: "Descargar set completo",
    tc_generating: "Generando...",
    tc_download_sheet: "Descargar (8.5 × 11)",
    tc_open_sheet: "Toca una hoja para verla y descargar",

    rec_next_eyebrow: "Sigue Aprendiendo",
    rec_next_title: "Recomendado a Continuacion",

    tools_title: "Herramientas de Fotografia",
    tools_subtitle: "Herramientas utiles para aprender y calcular rapido",
    tools_exposure_title: "Triangulo de Exposicion",
    tools_exposure_desc: "Entiende como la apertura, velocidad e ISO trabajan juntos.",
    tools_exposure_aperture: "La apertura controla la profundidad de campo. Mas abierta (f menor) = menos profundidad + mas luz.",
    tools_exposure_shutter: "La velocidad controla el movimiento. Mas rapida = congela el movimiento pero entra menos luz.",
    tools_exposure_iso: "El ISO controla la sensibilidad. Mas alto = imagen mas brillante pero mas ruido.",
    tools_dof_title: "Calculadora de Profundidad de Campo",
    tools_dof_desc: "Calcula cuanto de tu escena estara en foco.",
    tools_dof_focal: "Distancia Focal (mm)",
    tools_dof_aperture: "Apertura (f/)",
    tools_dof_distance: "Distancia al Sujeto",
    tools_dof_sensor: "Tamano del Sensor",
    tools_dof_result: "Profundidad de Campo",
    tools_dof_near: "Limite cercano",
    tools_dof_far: "Limite lejano",
    tools_dof_total: "PDC Total",
    tools_dof_meters: "m",
    tools_dof_infinity: "Infinito",
    tools_handheld_title: "Velocidad Minima sin Tripode",
    tools_handheld_desc: "Calcula la velocidad mas lenta segura para disparar sin tripode.",
    tools_handheld_result: "Velocidad Minima",
    tools_sunny16_title: "Referencia Rapida Sunny 16",
    tools_sunny16_desc: "Reglas clasicas de exposicion a ISO 100.",
    tools_sunny16_bright: "Sol Brillante",
    tools_sunny16_cloudy: "Nublado",
    tools_sunny16_shade: "Sombra",
    tools_sunny16_sunset: "Atardecer/Amanecer",
    tools_crop_factor: "Factor de Recorte",

    form_event_scenario: "Evento / Escenario de Sesion",
    form_primary_goal: "Objetivo Principal",

    event_none: "Ninguno",
    event_wedding: "Boda",
    event_indoor_concert: "Concierto Interior",
    event_outdoor_concert: "Concierto al Aire Libre",
    event_graduation: "Retratos de Graduacion",
    event_sports: "Evento Deportivo",
    event_birthday: "Fiesta de Cumpleanos",
    event_church: "Evento en Iglesia",
    event_family: "Sesion Familiar",
    event_corporate: "Evento Corporativo",
    event_night_event: "Evento Nocturno",
    event_indoor_studio: "Estudio Fotografico Interior",
    event_outdoor_studio: "Estudio Fotografico Exterior",

    goal_none: "Ninguno",
    goal_portraits: "Retratos",
    goal_candid: "Momentos Espontaneos",
    goal_group: "Fotos Grupales",
    goal_stage_action: "Accion en Escenario",
    goal_closeups: "Primeros Planos",
    goal_wide_environmental: "Tomas Amplias del Entorno",
    goal_detail_shots: "Fotos de Detalles",

    eg_title: "Guia del Evento",
    eg_lens: "Lente Recomendado",
    eg_flash: "Flash",
    eg_gear: "Equipo de Apoyo",
    eg_tips: "Consejos de Disparo",
    eg_cautions: "Precauciones",

    event_wedding_lens: "24-70mm para cobertura general, 70-200mm para distancia en la ceremonia, 50mm u 85mm para retratos.",
    event_wedding_flash: "Flash rebotado para la recepcion. Evita el flash directo fuerte.",
    event_wedding_gear: "Baterias extra, tarjetas de memoria extra, flash con difusor.",
    event_wedding_tips: "Preparate para cambios de luz. Captura momentos espontaneos entre poses. Usa angulares para grupos. Reconoce los espacios antes.",
    event_wedding_cautions: "No pierdas momentos clave (primer beso, anillos, ramo). Coordina con el organizador sobre las restricciones.",

    event_indoor_concert_lens: "Lente rapido (35mm o 50mm f/1.8) o teleobjetivo zoom (70-200mm f/2.8).",
    event_indoor_concert_flash: "Generalmente no se permite flash. Usa la iluminacion del escenario.",
    event_indoor_concert_gear: "Baterias extra, tarjetas de alta capacidad.",
    event_indoor_concert_tips: "La iluminacion cambia rapidamente — protege las luces altas. Prioriza velocidad rapida para la accion. Dispara en RAW.",
    event_indoor_concert_cautions: "Cuidado con el balance de blancos bajo luces mixtas. Respeta las reglas del recinto.",

    event_outdoor_concert_lens: "Teleobjetivo zoom (70-200mm) o zoom flexible (24-105mm).",
    event_outdoor_concert_flash: "Generalmente no se necesita flash de dia. No es efectivo a distancia de noche.",
    event_outdoor_concert_gear: "Baterias extra, parasol para proteccion solar.",
    event_outdoor_concert_tips: "La distancia y luz cambiantes requieren flexibilidad. Dispara durante la prueba de sonido si es posible.",
    event_outdoor_concert_cautions: "La posicion del sol cambia durante el evento. Protege el equipo del clima y polvo.",

    event_graduation_lens: "50mm u 85mm para retratos, 24-70mm para versatilidad.",
    event_graduation_flash: "Flash de relleno al aire libre si es necesario. Flash rebotado en interiores.",
    event_graduation_gear: "Reflector opcional para retratos al aire libre.",
    event_graduation_tips: "Usa focales favorecedoras (50-85mm). Vigila distracciones en el fondo. Captura el momento de entrega del diploma.",
    event_graduation_cautions: "Las ceremonias pueden ser largas — conserva bateria. Los asientos pueden limitar tus angulos.",

    event_sports_lens: "Teleobjetivo, idealmente 70-200mm f/2.8 o mas largo (100-400mm).",
    event_sports_flash: "Generalmente no se permite flash o no es efectivo a distancia.",
    event_sports_gear: "Monopie para lentes largos, baterias extra, tarjetas rapidas.",
    event_sports_tips: "Prioriza velocidad rapida (1/500+). Anticipa el movimiento. Sigue la accion con enfoque continuo.",
    event_sports_cautions: "La iluminacion exterior cambia con el sol. Los recintos interiores tienen luz mixta desafiante.",

    event_birthday_lens: "24-70mm o 35mm fijo para espacios reducidos.",
    event_birthday_flash: "Flash rebotado en techo o paredes para un look natural.",
    event_birthday_gear: "Baterias extra, flash externo.",
    event_birthday_tips: "Captura el corte de pastel, apertura de regalos y reacciones. Usa angulares en espacios pequenos.",
    event_birthday_cautions: "Las fiestas interiores suelen tener poca luz mixta. Cuidado con sombras duras del flash directo.",

    event_church_lens: "Lente rapido (50mm f/1.8) o 24-70mm f/2.8.",
    event_church_flash: "Usa solo si esta permitido. Modo silencioso preferido.",
    event_church_gear: "Baterias extra. Usa modo silencioso si esta disponible.",
    event_church_tips: "Respeta el evento y trabaja discretamente. Posicionate con cuidado. Usa luz ambiente cuando sea posible.",
    event_church_cautions: "El flash puede no estar permitido. El movimiento y ruido del obturador pueden ser disruptivos.",

    event_family_lens: "50mm u 85mm para retratos, 35mm para tomas ambientales.",
    event_family_flash: "Luz natural preferida. Flash de relleno para sombras duras al aire libre.",
    event_family_gear: "Reflector, baterias extra.",
    event_family_tips: "Interactua con los sujetos para expresiones naturales. Dispara a la altura de los ojos de los ninos. La hora dorada da luz hermosa.",
    event_family_cautions: "Los ninos se mueven impredeciblemente — manten la velocidad alta. Vigila fondos distractores.",

    event_corporate_lens: "24-70mm para versatilidad, 70-200mm para escenario y ponentes.",
    event_corporate_flash: "Flash rebotado para networking. Evita interrumpir presentaciones.",
    event_corporate_gear: "Baterias extra, tarjetas de memoria, segundo cuerpo si es posible.",
    event_corporate_tips: "Captura ponentes, asistentes en networking, detalles del lugar y senaletica. Entrega imagenes rapidamente.",
    event_corporate_cautions: "Entorno profesional — se discreto. Algunas presentaciones pueden restringir la fotografia.",

    event_night_event_lens: "Lente rapido preferido (35mm o 50mm f/1.4-f/1.8).",
    event_night_event_flash: "Flash rebotado si es apropiado. Evita flash directo fuerte.",
    event_night_event_gear: "Baterias extra (el flash las consume mas rapido), tripode si es posible.",
    event_night_event_tips: "Equilibra desenfoque y ruido con cuidado. Vigila dominantes de color de luces mixtas. Usa flash creativamente.",
    event_night_event_cautions: "ISO alto sera necesario — el ruido es esperado. Aceptalo o planea reduccion de ruido en post.",

    event_indoor_studio_lens: "50mm u 85mm para retratos, 24-70mm para versatilidad, macro para detalle de producto.",
    event_indoor_studio_flash: "Estrobos o speedlights con modificadores (softbox, paraguas). LED continuo para video o previsualizar luz.",
    event_indoor_studio_gear: "Soportes de luz, softboxes, reflectores, fondos, baterias extra, cable de conexion opcional.",
    event_indoor_studio_tips: "Controla cada variable — iluminacion, fondo, posicion del sujeto. Usa medidor de luz o histograma. Dispara conectado para revisar en pantalla grande.",
    event_indoor_studio_cautions: "Cuidado con dominantes de color de fuentes de luz mixtas. Manten ISO bajo ya que controlas la luz. Revisa reflejos no deseados en gafas o superficies brillantes.",

    event_outdoor_studio_lens: "85mm o 70-200mm para retratos, 35mm o 50mm para tomas ambientales, 24-70mm para versatilidad.",
    event_outdoor_studio_flash: "Flash de relleno o reflector para equilibrar sol fuerte. Flash externo para iluminacion creativa.",
    event_outdoor_studio_gear: "Reflector, difusor, soportes de luz (bolsa de arena para viento), baterias extra, fondos opcionales.",
    event_outdoor_studio_tips: "Dispara en hora dorada para mejor luz natural. Usa sombra o difusores para suavizar sol del mediodia. Posiciona sujetos con luz detras para contraluz.",
    event_outdoor_studio_cautions: "El clima y viento pueden cambiar rapido — asegura el equipo. Sol directo causa sombras duras y deslumbramiento. Vigila distracciones en el fondo.",

    goal_portraits_tip: "Usa rango de 50-85mm para perspectiva favorecedora. Separa al sujeto del fondo con apertura amplia. Busca luz suave y direccional.",
    goal_candid_tip: "Mantente discreto con focal moderada (35-50mm). Estate listo para disparar rapido — manten la camara en el ojo.",
    goal_group_tip: "Usa rango de 24-35mm para grupos. Usa f/5.6 o mas cerrado para que todos salgan nitidos. Organiza en filas escalonadas.",
    goal_stage_action_tip: "Usa el lente mas largo disponible. Pre-enfoca en areas clave del escenario. Usa enfoque continuo para seguir a los artistas.",
    goal_closeups_tip: "Usa 50mm+ a corta distancia o lente macro. Presta atencion a la profundidad de campo — incluso un movimiento leve cambia el enfoque.",
    goal_wide_environmental_tip: "Usa rango de 16-35mm. Incluye contexto y entorno para contar la historia del evento y la ubicacion.",
    goal_detail_shots_tip: "Usa rango de 50-100mm. Aisla sujetos con poca profundidad de campo. Busca texturas, patrones y pequenos momentos.",

    nav_gear: "Mi Equipo",
    gear_title: "Mi Inventario de Equipo",
    gear_subtitle: "Guarda tu equipo para recomendaciones personalizadas",
    gear_cameras: "Cuerpos de Camara",
    gear_film_cameras: "Camaras de Pelicula",
    gear_film_cameras_hint: "Los cuerpos analogicos de 35mm no tienen EXIF digital — agregalos aqui para llevarlos en tu inventario.",
    film_full_frame_tag: "Full-Frame 35mm",
    gear_lenses: "Lentes",
    gear_lighting: "Iluminacion",
    gear_support: "Equipo de Apoyo",
    gear_add_lens: "Agregar Lente",
    gear_lens_name: "Nombre del Lente",
    gear_focal_min: "Focal (mm)",
    gear_focal_max: "Max (mm)",
    gear_max_aperture: "Apertura",
    gear_optional: "Zoom",
    gear_speedlight: "Speedlight / Flash",
    gear_led_panel: "Panel LED",
    gear_strobe: "Estrobo de Estudio",
    gear_light_meter: "Fotometro de Mano (ej. Sekonic, Sonic)",
    gear_color_checker: "Color Checker (ej. SpyderCHECKR, X-Rite Passport)",
    gear_tripod: "Tripode",
    gear_monopod: "Monopie",
    gear_reflector: "Reflector",
    gear_save: "Guardar Equipo",
    gear_saved: "Equipo guardado!",
    gear_login_required: "Inicia sesion para gestionar tu inventario de equipo.",
    gear_no_lenses: "Aun no hay lentes agregados.",
    inv_model: "Modelo",
    inv_serial: "Numero de Serie",
    inv_quantity: "Cantidad",
    inv_condition: "Condicion",
    inv_location: "Ubicacion Actual",
    inv_purchase_date: "Fecha de Compra",
    inv_purchase_price: "Precio de Compra",
    inv_remarks: "Observaciones",
    inv_remarks_placeholder: "Notas adicionales...",
    inv_download: "Descargar Excel",
    inv_downloaded: "Inventario descargado!",
    inv_no_items: "No hay equipo para exportar. Agrega items primero.",
    gear_accessories: "Accesorios",
    gear_accessories_hint: "Fondos, kits de iluminacion, filtros, bolsas, controles remotos — cualquier otro equipo.",
    gear_accessory_placeholder: "ej. Softbox, Filtro ND, Pantalla Verde...",
    gear_add: "Agregar",
    gr_title: "De Tu Equipo",
    gr_ideal_label: "Configuracion Ideal",
    gr_empty_state: "Aun no tienes equipo guardado. Agrega tu equipo para obtener recomendaciones personalizadas.",
    gr_best_lens: "Mejor Lente para Esta Toma",
    gr_lighting_rec: "Iluminacion",
    gr_support_rec: "Equipo de Apoyo",
    gr_missing: "Adiciones Sugeridas",
    gr_no_lens_match: "No hay lente compatible en tu inventario para este escenario.",
    gr_reason_portrait_prime: "Ideal para retratos — un prime rapido crea un hermoso desenfoque de fondo y nitida separacion del sujeto.",
    gr_reason_portrait_zoom: "Buen rango para retratos — cubre las focales favorecedoras de 50-85mm.",
    gr_reason_sports_tele: "Gran alcance para accion — el teleobjetivo te permite capturar el momento desde la distancia.",
    gr_reason_sports_reach: "Usable para deportes, aunque mas alcance ayudaria a capturar accion distante.",
    gr_reason_landscape_wide: "El gran angular captura escenas amplias con perspectiva dramatica y detalle de borde a borde.",
    gr_reason_landscape_general: "Adecuado para paisaje — captura buena parte de la escena.",
    gr_reason_macro: "Disenado para trabajo de cerca — ofrece la magnificacion y nitidez que necesitas.",
    gr_reason_fast_aperture: "La apertura rapida ayuda a captar luz y crea una agradable separacion del fondo.",
    gr_reason_versatile: "Opcion versatil que cubre un rango focal util para este escenario.",
    gr_use_speedlight: "Usa tu speedlight — se recomienda flash rebotado.",
    gr_use_led: "Tu panel LED puede ayudar como luz de relleno continua.",
    gr_no_flash_needed: "Suficiente luz ambiente — no se necesita flash.",
    gr_use_tripod: "Usa tu tripode para resultados mas nitidos a esta velocidad.",
    gr_use_monopod: "Tu monopie puede ayudar a estabilizar a esta velocidad.",
    gr_no_support_needed: "Disparar a mano esta bien para estos ajustes.",
    gr_suggest_telephoto: "Para deportes a distancia, un 70-200mm f/2.8 te permitiria congelar la accion desde las gradas.",
    gr_suggest_wide: "Para paisajes, un gran angular (16-35mm) captaria toda la escena con perspectiva dramatica.",
    gr_suggest_fast_prime: "Un prime rapido como un 50mm f/1.8 mejoraria dramaticamente tu rendimiento en poca luz aqui.",
    gr_suggest_macro: "Para detalle de cerca, un macro dedicado ofrece magnificacion que los lentes estandar no logran.",
    gr_suggest_speedlight: "Un speedlight con rebote te daria luz mucho mas limpia en interiores.",
    gr_suggest_tripod: "Un tripode te permitiria usar velocidades mas lentas para imagenes limpias en vez de subir el ISO.",
    gr_suggest_monopod: "Un monopie ayudaria a estabilizar tu teleobjetivo para resultados mas nitidos sin el peso de un tripode.",
    gr_suggest_portrait_prime: "Un prime rapido para retratos (50mm u 85mm f/1.8) te daria un hermoso desenfoque y sujetos mas nitidos.",
  },
};

export default translations;
